import { Component, HostListener, OnInit } from '@angular/core';
import { Config } from 'src/app/config/constants';
import { UserService } from 'src/app/core/services/user.service';
//import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl} from '@angular/platform-browser'
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { BaseService } from 'src/app/core/services/base.service';
//import { interval } from 'rxjs';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-upload-documents',
  templateUrl: './upload-documents.component.html',
  styleUrls: ['./upload-documents.component.scss'],
  providers: [DatePipe]
})
export class UploadDocumentsComponent implements OnInit {
  todayDate: Date;
  showdocuments: boolean = false;
  showdocumentsAgency: boolean=false;
  minDate = new Date();
  uploadlicenseArray: Array<any> = [];
  uploadvoidchequeArray: Array<any> = [];
  newAttribute: any = {};
  newAttributenext: any = {};
  //fileData=new FormData(); 
  licenseArray: Array<any> = [];
  licenseAttribute: any = {};
  showlicense: boolean = false;
  showlicense1: boolean = false;
  showcheque: boolean = false;
  showdocumentModal: any;
  showemailErrorMsg: boolean;
  showemailErrorMsg1: boolean = false;
  fileeno: any;
  fileeno1: any;
  expiryDate: any;
  msgfinal: any;
  msg: any;
  filelicens: any;
  showemailErrorMsgone: boolean;
  showdateErrorMsg: boolean;
  showEffectivedateErrorMsg: boolean;
  province: any;
  error: any;
  productPhotofile: any;
  productPhotofile1: any;
  leadId: string;
  loading: boolean;
  FileDataList: any;
  FileDataList1: any;
  licenseType: any;
  licenseNumber: any;
  expiryDateLic: any;
  expiryDateLic1: any;
  EffectiveDateLic1: any;
  showlicdErrorMsgone: boolean;
  showlicEffectivedErrorMsgone: boolean;
  showlictErrorMsgone: boolean;
  showlicnErrorMsgone: boolean;
  FileDataListLic: any;
  provienceList: any;
  showlicpErrorMsgone: boolean;
  showlicnameErrorMsgone: boolean;
  licenseName: any;
  showExpiry: any;
  showExpiry1: any;
  showDocumentName: any;
  showDocumentName1: any;
  finalDocs: any;
  finalDocs1: any;
  deleteModal: any;
  fileenoNameLic: any;
  fileenoName1: any;
  showdocuments1: boolean = false;
  deleteModal3: boolean = false;
  deleteModal2: boolean = false;
  fileUrlForEno: any;
  Url: any;
  licensPreview: any;
  voidPreview: any;
  policyNumber: any;
  showPolicyNumber: any;
  doctrimtoUrl: any;
  doctrimUrl: any;
  docId: any;
  checkedDoc: any;
  checkDocdesc:any;
  refreshToken: any;
  uploadDocStatus: boolean = false;
  //stagesViews: any;
  isUploaddoc: boolean = true;
  isCompleted: boolean = true;
  fileenoName3: any;
  isCompletedPI: boolean = true;
  isCompletedPI1: boolean = false;
  isInprogressUD: boolean = false;
  acceptedExtensions = ["jpg", "jpeg", "png", "pdf", "docx", "JPG", "JPEG", "PNG", "PDF", "DOCX"];
  showbtn: any;
  isFirstTimeProceed: boolean=false;
  docFileId: any=null;
  commitionTo: any;
  commissionsTo:any;
  showRemove: boolean=false;
  uploadEOPopup:boolean=false;
  uploadLicensePopup: boolean=false;
  uploadVoidChequePopup: boolean=false;
  showCompany: boolean=false;
  agencyId: any;
  licencesType=[];
  showlicenseAgency: boolean=false;
  showchequeAgency: boolean=false;
  companydocmodal: boolean=false;
  revertcompanydoc: boolean=false;
  showRemove1: boolean=false;
  showCompanyDelete:boolean=false;
  showdocumentsNA: boolean=true;
  showlicense1NA: boolean=true;
  showchequeNA: boolean=true;
  showdocumentsAgencyNA: boolean=true;
  showlicenseAgencyNA: boolean=true;
  showchequeAgencyNA: boolean=true;
  isFirstTimeUploadedEOIndividual: boolean=false;
  isFirstTimeUploadedEOCompany: boolean=false;
  isEditableDocumentEOIndividual: boolean=false;
  isEditableDocumentEOCompany: boolean=false;
  Type:any;
  leadType:any;
  mgaId: any;
  isOverWriteEO: boolean=false;
  documentType: string | Blob;
  type: any;
  mgaName: any;
  fileId: null;
  editMGAShortName: boolean=false;
  isEditableDocumentEOMGA: boolean=false;
  isFirstTimeUploadedEOMGA: boolean=false;
  callMgaAPI: boolean=false;
  showMgaTab: boolean=false;
  BankInfo :boolean = false;
  EditBankInfo :boolean = false;
  // banking info
  voidIndexitem: any;
  indexno: any;
  // BankName: any;
  // holderName: any;
  // branchAddress: any;
  confirmaccountNo: any;
  confirmaccountNoErrMsg: boolean=false;
  transitNo: any;
  financialInstitutionNo: any ;
  accountNo: any;
  maskaccountNo: any;
  // holderNameErrMsg: boolean=false;
  // BankNameErrMsg: boolean=false;
  // branchAddressErrMsg: boolean=false;
  transitNoErrMsg: boolean=false;
  financialInstitutionNoErrMsg: boolean=false;
  accountNoErrMsg: boolean=false;
  bankName : any;
  popupName="Add";
  btnPopupName ="Save"
  btncancelPopupName ="Cancel"
  bankNm: any;
  holdeNm: any;
  holderNm: any;
  branchAdr: any;
  transitNm: any;
  financialInstNumber: any;
  accNm: any;
  confirmAccNo: any;
  bankinfoChecked: boolean=false;
  bankInfoErrmsg: boolean=false;
  eyeIconShowAccountNumber: boolean =false;
  eyeIcon: boolean=false;
  effectiveDate: string;
  residentProvince: any;
  residentLicPresent:boolean=false
  showforProceed: boolean=false;
  isDocumentRequested: boolean=false;
  requestedData: any;
  // btnPopupNameNew: "Save";
  // end banking info
  otpTimerDisplaySIN: string = '';
  otpTimerSIN: any;
  remainingSecondsSIN: number = 300;
  isOtpExpiredSIN: boolean = false;
  constructor(public user: UserService, public config: Config, public router: Router, private DatePipe:DatePipe,private base: BaseService,private toastr: ToastrService) {
    //   this.stagesViews= JSON.parse(sessionStorage.getItem('stagesViews')) 
    //this.getDashboard();
    this.todayDate = new Date();
  }
  personalinfo: any;
  showdocumentsMGA:boolean=false
showlicenseMGA:boolean=false
showchequeMGA:boolean=false
showdocumentsMgaNA:boolean=false
showlicenseMgaNA:boolean=false
showchequeMgaNA:boolean=false
  ngOnInit(): void { 
    
    this.leadId = sessionStorage.getItem('leadId');
    this.leadType=sessionStorage.getItem('leadtype')
    this.DocmoreInfoReq(this.leadId)
    this.getDashboard();
    this.getDocument();
    this.minDate.setHours(0, 0, 0, 0);
    this.getMiscDocument();
    this.getLicensRequest();
    this.getEORequest();
    this.getVoidChequeRequest();
  }
  getDashboard() {
    this.user.getDashboardData().pipe()
      .subscribe(
        data => {
            
          this.personalinfo = data.data.leads;
          this.commissionsTo = data.data.leads.commitionTo;
          this.Type = data.data.leads.type;
          this.leadType = data.data.leads.type;
          this.residentProvince = data.data.leads.primaryAddressProvince;
          sessionStorage.setItem('leadtype',data.data.leads.type)
          try{
            this.agencyId = this.personalinfo.agencyId
            this.mgaId = this.personalinfo.agencyMgaId
            this.type = this.personalinfo.type
            if(this.type=='MGA Rep'){
              this.showMgaTab=true
            }
            this.mgaName = this.personalinfo.agencyMgaName
            // this.mgaName = this.personalinfo.mgaShortName;
            if(this.mgaName==null){
             this.mgaName = this.personalinfo.agencyMgaName;
            }
          }catch{

          }

          if(this.personalinfo.isCompanyRegister == true){
            this.showCompany = true;
          }
          
          if (this.personalinfo.stagesViews != null || undefined) {
            sessionStorage.setItem('stagesViews', JSON.stringify(this.personalinfo.stagesViews))
            this.showbtn=this.personalinfo.stagesViews[1].isEditable
            this.isFirstTimeProceed=this.personalinfo.stagesViews[1].isFirstTime
            if (this.personalinfo.stagesViews[0].isCompleted === false && this.personalinfo.stagesViews[0].isApproved === false) {
              this.isCompletedPI = false
              this.isCompletedPI1 = false
            }
            else if (this.personalinfo.stagesViews[0].isCompleted === true && this.personalinfo.stagesViews[0].isApproved === false) {
             this.isCompletedPI = false
             this.isCompletedPI1 = false
            }
            else {
              this.isCompletedPI = true;
              this.isCompletedPI1 = true;
            }
            if (this.personalinfo.stagesViews[1].isCompleted === true && this.personalinfo.stagesViews[1].isApproved === true) {
            
            
              this.isUploaddoc = true;
              this.isCompleted = true;
            }
           else if (this.personalinfo.stagesViews[1].isCompleted === true && this.personalinfo.stagesViews[1].isApproved === false) {
              this.isUploaddoc = false;
              this.isCompleted = true;
              this.isInprogressUD = true;
             
            }
            else{
              this.isUploaddoc = false;
              this.isCompleted = false;
            }
            
          }
          if (this.personalinfo.stagesViews[0].isCompleted === true && this.personalinfo.stagesViews[0].isApproved === false) {
            this.router.navigate(['/dashboard/personal-info']);
          }
          else if (this.personalinfo.stagesViews[1].isCompleted === true && this.personalinfo.stagesViews[1].isApproved === false) {
            this.router.navigate(['/dashboard/upload-documents']);
          }
          else if (this.personalinfo.stagesViews[2].isCompleted === true && this.personalinfo.stagesViews[2].isApproved === false) {
            this.router.navigate(['/dashboard/contract-sign']);
          }
          else if (this.personalinfo.stagesViews[3].isCompleted === true && this.personalinfo.stagesViews[3].isApproved === false) {
            this.router.navigate(['/dashboard/online-training']);
          }
          else {
            this.router.navigate(['/dashboard/personal-info']);
          }
          if(this.personalinfo.stagesViews[0].isCompleted === true &&
            this.personalinfo.stagesViews[0].isApproved === true   &&
         this.personalinfo.stagesViews[1].isCompleted === true &&
            this.personalinfo.stagesViews[1].isApproved === true   &&
        this.personalinfo.stagesViews[2].isCompleted === true &&
            this.personalinfo.stagesViews[2].isApproved === true &&
        this.personalinfo.stagesViews[3].isCompleted === true &&
            this.personalinfo.stagesViews[3].isApproved === true)
            {
             this.router.navigate(['/activated']);
       }
      
        }, error => {
        }, () => { });
  }
  
  tabs2 = [
    { active2: 'active2', tabcontent2: 'tabcontent2' },
    { active2: '', tabcontent2: 'hide' },
    { active2: '', tabcontent2: 'hide' },
    { active2: '', tabcontent2: 'hide' },
    { active2: '', tabcontent2: 'hide' },
    { active2: '', tabcontent2: 'hide' },
    { active2: '', tabcontent2: 'hide' },
    { active2: '', tabcontent2: 'hide' },
    
    ];
    openTabs2(index){
      this.reset2();
      this.tabs2[index].active2 = 'active2';
      this.tabs2[index].tabcontent2 = 'tabcontent2';
      if(index==0){
        this.showLicTypeonPopup=this.individualLicType;
      }
      if(index==1){
        this.showLicTypeonPopup=this.corporateLicType;
      }
      if(index==2){
        this.showLicTypeonPopup=this.MgaLicType;
      }
    }
    callAgencyDoc(){
      this.callMgaAPI=false
      this.getAgencyDocuments(this.agencyId,this.leadId);
      this.openTabs2(1)
      this.getLicensRequest()
      this.getEORequest();
      this.getVoidChequeRequest();
      this.fileenoNameLic=null;
      this.fileenoName=null;
      this.fileenoName1=null;
      this.uploadlicenseArray = [];
      this.getLicencesData=[];
      this.uploadvoidchequeArray = [];
      this.fileeno=""
      this.policyNumber=""
      this.expiryDate1=""
      this.effectiveDate1=""
      this.bankinfoChecked=false
    }
    callIndividualDoc(){
      this.getLicensRequest()
      this.getEORequest();
      this.getVoidChequeRequest();
    this.getDocument();
    this.openTabs2(0)
    this.fileenoNameLic=null;
    this.fileenoName=null;
    this.fileenoName1=null;
    this.uploadlicenseArray = [];
    this.getLicencesData=[];
    this.getLicencesDataBroker=[];
    this.uploadvoidchequeArray = [];
    this.fileeno=""
      this.policyNumber=""
      this.expiryDate1=""
      this.effectiveDate1=""
      this.bankinfoChecked=false
    }
    
    reset2() {
    for (let i = 0; this.tabs2.length > i; i++) {
    this.tabs2[i].active2 = '';
    this.tabs2[i].tabcontent2 = 'hide';
    }
    }
  uploaddocs() {
    
    this.showdocuments = true;
    // if (this.showdocuments && this.showlicense1 && this.showcheque) {
    // this.uploadDocStatus = true;
    // }
  }
  uploaddocsAgency() {
    this.showdocumentsAgency = true;
    // if (this.showdocuments && this.showlicense1 && this.showcheque) {
    // this.uploadDocStatus = true;
    // }
  }
  uploadlicstatus() {
    this.showlicense1 = true;
    // if (this.showdocuments && this.showlicense1 && this.showcheque) {
    //   this.uploadDocStatus = true;
    //   }
  }
  uploadlicstatusAgency() {
     this.showlicenseAgency = true;
    // if (this.showdocuments && this.showlicense1 && this.showcheque) {
    //   this.uploadDocStatus = true;
    //   }
  }
  uploadvoidstatus() {
    this.showcheque = true;
    // if (this.showdocuments && this.showlicense1 && this.showcheque) {
    //   this.uploadDocStatus = true;
    //   }
  }
  uploadvoidstatusAgency() {
    
    this.showchequeAgency = true;
    // if (this.showdocuments && this.showlicense1 && this.showcheque) {
    //   this.uploadDocStatus = true;
    //   }
  }
  removedocs() {
    if(this.showCompanyDelete==false && this.callMgaAPI==false){
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.user.deleteDoc(this.docId).pipe()
          .subscribe(
            data => {
              this.fileeno = ""
              this.showemailErrorMsg = false
              this.fileenoName = ""
              this.expiryDate = ""
              this.policyNumber = ""
              
              // this.showExpiry= ""
              Swal.fire('Deleted!',
              'The document has been removed successfully.',
              'success')
              this.showdocuments = false;
              this.getDocumentDeleteCheck();
            }, error => {
    
              if (error.status == 400 || error.status == 417) {
                this.error = error.error.data;
              }
              else {
    
                this.error = "Something went wrong";
              }
    
            }, () => { });
      }
    })
  }else if(this.showCompanyDelete==true && this.callMgaAPI==false){
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.user.deleteDocAgency(this.docId).pipe()
          .subscribe(
            data => {
              this.fileeno = ""
              this.showemailErrorMsg = false
              this.fileenoName = ""
              this.expiryDate = ""
              this.policyNumber = ""
              // this.showExpiry= ""
              Swal.fire('Deleted!',
              'The document has been removed successfully.',
              'success')
              this.showdocumentsAgency = false;
              this.getAgencyDocumentsForDelete(this.agencyId,this.leadId);
              this.openTabs2(1)
            }, error => {
    
              if (error.status == 400 || error.status == 417) {
                this.error = error.error.data;
              }
              else {
    
                this.error = "Something went wrong";
              }
    
            }, () => { });
      }
    })
  }
  else{
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.user.deletedocumentMga(this.docId).pipe()
          .subscribe(
            data => {
              this.fileeno = ""
              this.showemailErrorMsg = false
              this.fileenoName = ""
              this.expiryDate = ""
              this.policyNumber = ""
              // this.showExpiry= ""
              Swal.fire('Deleted!',
              'The document has been removed successfully.',
              'success')
              this.showdocumentsAgency = false;
              this.getMGADocuments();
              this.openTabs2(2)
            }, error => {
    
              if (error.status == 400 || error.status == 417) {
                this.error = error.error.data;
              }
              else {
    
                this.error = "Something went wrong";
              }
    
            }, () => { });
      }
    })
  }
  }
  addFieldValue() {
    this.uploadlicenseArray.push(this.newAttribute)
    this.newAttribute = {};
  }
  deleteFieldValue(index) {
    // Swal.fire({
    //   title: 'Are you sure?',
    //   // text: "You won't be able to revert this!",
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: 'Yes, delete it!'
    // }).then((result) => {
    //   if (result.isConfirmed) {
       
    //     Swal.fire(
    //       'Deleted!',
    //       'Your file has been deleted.',
    //       'success'
    //     )
    //   }
    // })
    this.uploadlicenseArray.splice(index, 1);
  }

  addFieldValuecheque() {
    this.uploadvoidchequeArray.push(this.newAttributenext)
    this.newAttributenext = {};
    //this.uploaddocs2();
  }
  deleteFieldValuecheque(index) {
    this.uploadvoidchequeArray.splice(index, 1);
  }

  onEoSelected() {
    // this.Url = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileUrlForEno)
    // this.Url = this.fileUrlForEno;
    this.user.getLeadPreviewLink(this.docFileId).pipe()
.subscribe(
    data => {
        
     console.log(data.data)
     this.Url=data.data
 
    },error=>{
   
        if(error.status == 400 || error.status==417){
            this.error=error.error.data;
           
         }
         else{
           
           this.error="Something went wrong.";
         }
    
        },()=>{});
    setTimeout(() => 
    {
      this.deleteModal = !this.deleteModal;
    },
    2500);
  }

  addValue() {
    this.licenseArray.push(this.licenseAttribute)
    this.licenseAttribute = {};
  }
  deleteValue(index) {
    this.licenseArray.splice(index, 1);
  }
  onPreviewLicens(url,fileIdLic) {
    // this.licensPreview = url;
    this.user.getLeadPreviewLink(fileIdLic).pipe()
    .subscribe(
        data => {
            
         console.log(data.data)
         this.licensPreview=data.data
     
        },error=>{
       
            if(error.status == 400 || error.status==417){
                this.error=error.error.data;
               
             }
             else{
               
               this.error="Something went wrong.";
             }
        
            },()=>{});
    setTimeout(() => 
    {
      this.deleteModal2 = !this.deleteModal2;
    },
    2500);
    // this.licensPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url)

  }
  // banking info
  uploadEno1Void(item,i){
    
    this.voidIndexitem=item;
    this.indexno=i;
  }
  onvoidPreview(url,voidfileId) {
    
    // this.voidPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url)
    // this.voidPreview = url;
    this.user.getLeadPreviewLink(voidfileId).pipe()
    .subscribe(
        data => {
            
         console.log(data.data)
         this.voidPreview=data.data
     
        },error=>{
       
            if(error.status == 400 || error.status==417){
                this.error=error.error.data;
               
             }
             else{
               
               this.error="Something went wrong.";
             }
        
            },()=>{});
    setTimeout(() => 
{
 this.deleteModal3 = !this.deleteModal3;
},
2500);
  }
  removelicense(i, id) {
    
    if(this.showCompanyDelete==false && this.callMgaAPI==false){
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.showlicense1 = false;
        this.user.deleteLicens(id).pipe()
          .subscribe(
            data => {
              if (data.success == true) {
                this.getDocumentDeleteCheck();
                Swal.fire(
                  'Deleted!',
                  'Your license has been removed successfully.',
                  'success'
                )
                //this.uploadlicenseArray.splice(i, 1);
                
                if (this.uploadlicenseArray.length == 0) {
                  this.uploadlicenseArray.push(this.newAttribute)
                  this.newAttribute = {};
                }
              }
            }, error => {
    
              if (error.status == 400 || error.status == 417) {
                this.error = error.error.data;
              }
              else {
    
                this.error = "Something went wrong";
              }
    
            }, () => { });
       
      }
    })
  }else if(this.showCompanyDelete==true && this.callMgaAPI==false){
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.showlicenseAgency = false;
        this.user.deleteLicensAgency(id).pipe()
          .subscribe(
            data => {
              if (data.success == true) {
                Swal.fire(
                  'Deleted!',
                  'Your license has been removed successfully.',
                  'success'
                )
                //this.uploadlicenseArray.splice(i, 1);
                this.getAgencyDocumentsForDelete(this.agencyId,this.leadId);
                this.openTabs2(1)
                if (this.uploadlicenseArray.length == 0) {
                  this.uploadlicenseArray.push(this.newAttribute)
                  this.newAttribute = {};
                }
              }
            }, error => {
    
              if (error.status == 400 || error.status == 417) {
                this.error = error.error.data;
              }
              else {
    
                this.error = "Something went wrong";
              }
    
            }, () => { });
       
      }
    })
  }
  else {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.showlicenseAgency = false;
        this.user.deletedocumentMga(id).pipe()
          .subscribe(
            data => {
              if (data.success == true) {
                Swal.fire(
                  'Deleted!',
                  'Your license has been removed successfully.',
                  'success'
                )
                //this.uploadlicenseArray.splice(i, 1);
                this.getMGADocuments();
              this.openTabs2(2)
              this.callMgaAPI==true;
                if (this.uploadlicenseArray.length == 0) {
                  this.uploadlicenseArray.push(this.newAttribute)
                  this.newAttribute = {};
                }
              }
            }, error => {
    
              if (error.status == 400 || error.status == 417) {
                this.error = error.error.data;
              }
              else {
    
                this.error = "Something went wrong";
              }
    
            }, () => { });
       
      }
    })
  }
   
  }

  removecheque(i) {
    this.showcheque = false;
  }

  expiryDate1:any;
  effectiveDate1:any;
  uploadEno() {
    
    var flag = true
    var errormsg = [];
    this.expiryDate = this.DatePipe.transform(this.expiryDate1, 'yyyy-MM-dd');
    this.effectiveDate = this.DatePipe.transform(this.effectiveDate1, 'yyyy-MM-dd');
    if (!this.fileeno || this.fileeno.length <= 0 || this.showemailErrorMsg == true) { this.showemailErrorMsg = true; flag = false; errormsg.push('Choose File') }
    if (!this.expiryDate || this.expiryDate.length <= 0) { this.showdateErrorMsg = true; flag = false; errormsg.push('Enter Expiry Date') }
    if (!this.policyNumber || this.policyNumber.length <= 0) { this.showdateErrorMsg = true; flag = false; errormsg.push('Enter E&O Policy Number') }
    if (this.enoSizeCheck==true) { this.showemailErrorMsg = true; flag = false; errormsg.push('Please upload the filesize less than 4MB') }
    if (!this.effectiveDate || this.effectiveDate.length <= 0) { this.showEffectivedateErrorMsg = true; flag = false; errormsg.push('Enter Effective Date') }

    
    if (flag == true) {
      if(this.isDocumentRequested==true){
        this.RequestedDocumentAddUpdateEO('EO')      
      }
else if(this.callMgaAPI==false){
      this.FileUpload();
    }
    else{
      this.documentType="EO"
      this.FileUploadMGA();
    }
    }
    else {
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replace(",", '<br />');
      Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')

    }
  }

  fileExtensionENO: any;
  fileExtensionErrorENO: boolean = false;
  fileExtensionMessageENO: any;
  fileenoName: string;
  enofile:File=null;
  enoSizeCheck: boolean =false;
  FileSelect(event) {
    
    // this.FileDataList=event.target.files;
    // this.fileenoName=this.FileDataList[0].name;
    this.fileenoName=""
    this.enofile = event.target.files[0];
    if(this.enofile.size>4194304){
      this.enoSizeCheck=true;

      Swal.fire({
        icon: 'error',
        text: 'Please upload the filesize less than 4MB',
      })
    }else{
      this.enoSizeCheck=false;
      this.showemailErrorMsg=false;
    }
    if (event.target.files.length > 0) {
      this.FileDataList = event.target.files;
      this.fileenoName = this.FileDataList[0].name;

      this.fileExtensionENO = this.fileenoName.split('.').pop();
      if (this.isInArray(this.acceptedExtensions, this.fileExtensionENO)) {
        this.fileExtensionErrorENO = false;
        this.fileExtensionMessageENO = ""

        this.showemailErrorMsg = this.fileExtensionErrorENO
        this.fileenoName = this.FileDataList[0].name;
      } else {
        this.fileExtensionMessageENO = "Invalid file type, Please select file with allowed file types: .pdf, .png , .jpeg or .docx "
        this.fileExtensionErrorENO = true;
        this.showemailErrorMsg = this.fileExtensionErrorENO
        this.fileenoName = this.fileExtensionMessageENO

      }

    } else {
      this.showemailErrorMsg = false;
      this.fileenoName = ""
    }

  }
  /*- checks if word exists in array -*/
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }
  FileUpload() {
    
    for (var i = 0; i < this.FileDataList.length; i++) {
      this.productPhotofile = this.FileDataList[i];
      if (this.productPhotofile != null) {
        const formData = new FormData();
        formData.append('file', this.productPhotofile);
        formData.append('expiryDate', this.expiryDate);
        formData.append('effectiveDate', this.effectiveDate);
        formData.append('policyNumber', this.policyNumber);
        var data = sessionStorage.getItem('leadId')
        formData.append('leadId', data);
        //  this.fileData=formData
        if(this.docId!=null){
          formData.append('documentId', this.docId)
          }
          if(this.docFileId!=null){
          formData.append('fileId', this.docFileId)
          }

          if(this.showCompanyDelete==true){
            formData.append('agencyId ', this.agencyId);
          }
        this.uploadImages(formData)
      }

    }
  }
  documentId: any;

  OverwriteEODoc(name){
  this.documentId=name;
    this.isOverWriteEO=true
  }

  async uploadImages(formData: FormData) {
    
    if(this.showCompanyDelete==false){
    this.loading = true;
    if(this.documentId==null){
    this.user.submitFormService(this.config.getEODocument, formData).subscribe((data: any) => {
      this.expiryDate = "";
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      this.finalDocs = data.data;
      this.loading = false;
      Swal.fire({
        text: data.message,  
        icon: 'success',      
        confirmButtonColor: '#CC4037',       
        confirmButtonText: 'Ok'
      }).then((result) => {
        if (result.isConfirmed) {
      this.ProceedPromt();
    }
  })
      this.uploadEOPopup=false;
      this.showExpiry = data.data.expiryDate;
      this.showDocumentName = data.data.documentName;
      this.showPolicyNumber = data.data.policyNumber;
      this.getDocument();
      this.uploaddocs()
      // this.fileId = data.data.id;
      // this.import();
    }, err => {
      //  this.dismiss();
    });
  }else{
    this.user.OverWriteEO(this.config.OverWriteEO, formData).subscribe((data: any) => {
     
      this.expiryDate = "";
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      this.finalDocs = data.data;
      this.loading = false;
      this.documentId=null;
      Swal.fire({
        text: data.message,  
        icon: 'success',      
        confirmButtonColor: '#CC4037',       
        confirmButtonText: 'Ok'
      }).then((result) => {
        if (result.isConfirmed) {
      this.ProceedPromt();
    }
  })
      this.uploadEOPopup=false;
      this.showExpiry = data.data.expiryDate;
      this.showDocumentName = data.data.documentName;
      this.showPolicyNumber = data.data.policyNumber;
      this.getDocument();
      this.uploaddocs()
    }, err => {
    });
  }
}
else{
  
  this.loading = true;
    if(this.documentId==null){
    this.user.submitFormService(this.config.uploadEoDOcAgency, formData).subscribe((data: any) => {
      this.expiryDate = "";
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      this.finalDocs = data.data;
      this.loading = false;
      Swal.fire({
        text: data.message,  
        icon: 'success',      
        confirmButtonColor: '#CC4037',       
        confirmButtonText: 'Ok'
      }).then((result) => {
        if (result.isConfirmed) {
      this.ProceedPromt();
    }
  })
      this.uploadEOPopup=false;
      this.showExpiry = data.data.expiryDate;
      this.showDocumentName = data.data.documentName;
      this.showPolicyNumber = data.data.policyNumber;
      this.getAgencyDocuments(this.agencyId,this.leadId);
      this.uploaddocs()
      // this.fileId = data.data.id;
      // this.import();
    }, err => {
      //  this.dismiss();
    });
  }else{
    this.user.OverWriteEO(this.config.updateEoDOcAgency, formData).subscribe((data: any) => {
     
      this.expiryDate = "";
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      this.finalDocs = data.data;
      this.loading = false;
      this.documentId=null;
      Swal.fire({
        text: data.message,  
        icon: 'success',      
        confirmButtonColor: '#CC4037',       
        confirmButtonText: 'Ok'
      }).then((result) => {
        if (result.isConfirmed) {
      this.ProceedPromt();
    }
  })
      this.uploadEOPopup=false;
      this.showExpiry = data.data.expiryDate;
      this.showDocumentName = data.data.documentName;
      this.showPolicyNumber = data.data.policyNumber;
      this.getAgencyDocuments(this.agencyId,this.leadId);
      this.uploaddocs()
    }, err => {
    });
  }
}
  }

  fileExtensionLic: any;
  fileExtensionErrorLic: boolean = false;
  fileExtensionMessageLic: any;
  licfile: File=null;
  FileSelectLic(event, i) {
    this.fileenoNameLic =""
    this.licfile = event.target.files[0];
    if(this.licfile.size>4194304){
      Swal.fire({
        icon: 'error',
        text: 'Please upload the filesize less than 4MB',
      })
    }

    if (event.target.files.length > 0) {
      this.FileDataListLic = event.target.files;
      this.fileenoNameLic = this.FileDataListLic[0].name;

      this.fileExtensionLic = this.fileenoNameLic.split('.').pop();
      if (this.isInArray(this.acceptedExtensions, this.fileExtensionLic)) {
        this.fileExtensionErrorLic = false;
        this.fileExtensionMessageLic = ""

        this.uploadlicenseArray[i].showemailErrorMsgone = this.fileExtensionErrorLic
        this.fileenoNameLic = this.FileDataListLic[0].name;
      } else {
        this.fileExtensionMessageLic = "Invalid file type, Please select file with allowed file types: .pdf, .png , .jpeg or .docx "
        this.fileExtensionErrorLic = true;
        this.uploadlicenseArray[i].showemailErrorMsgone = this.fileExtensionErrorLic
        this.fileenoNameLic = this.fileExtensionMessageLic

      }
      //this.uploadlicenseArray[i].showemailErrorMsgone=this.fileExtensionError;
      //this.fileenoNameLic=this.fileExtensionMessage;
    } else {
      this.uploadlicenseArray[i].showemailErrorMsgone = false;
      this.fileenoNameLic = ""
    }
  }
  FileUploadLic(uploadlic, k) {
    for (var i = 0; i < this.FileDataListLic.length; i++) {
      this.productPhotofile = this.FileDataListLic[i];
      if (this.productPhotofile != null) {
        const formData = new FormData();
        formData.append('file', this.productPhotofile);
        formData.append('expiryDate', uploadlic.expiryDateLic);
        formData.append('effectiveDate', uploadlic.effectiveDateLic);
        var data = sessionStorage.getItem('leadId');

        formData.append('leadId', data);
        formData.append('licencesNumber', uploadlic.licenseNumber);
        formData.append('lincencesName', uploadlic.licenseName);

        formData.append('licencesType', uploadlic.type);
        formData.append('province', uploadlic.province);

        if(this.licensRequestId !=null ){
          formData.append('requestedId', this.licensRequestId);
        }

        // this.fileData=formData
        if(this.fileIdlic!=null){
          formData.append('fileId', this.fileIdlic);
        }
        if(this.licenceId!=null){
          formData.append('licenceId', this.licenceId);
        }
        if(this.showCompanyDelete==true){
          formData.append('agencyId ', this.agencyId);
        }
        this.uploadImagesLic(formData, k)
      }

    }
  }
  fileIdlic: any;
  licenceId: any;
  OverwriteLic(licval,i){
    
    this.fileIdlic=licval.fileId

    this.licenceId=licval.id;
     var obj={
    "province":licval.licencesProvince,
    "type":licval.type,
     }
     
     this.getLicencesData=[];
    this.getLicencesData.push(obj)
   // this.uploadlicenseArray[i].type=licval.type
    console.log(this.getLicencesData[i])
    this.isOverWriteEO=true
  }

  async uploadImagesLic(formData: FormData, k) {
    if(this.showCompanyDelete==false){
    this.loading = true;
    if(this.licenceId==null){
      if(this.licensRequestId != null){
        this.user.submitFormService(this.config.getLicDocumentRequested, formData).subscribe((data: any) => {
          this.loading = false;
          this.uploadLicensePopup=false;
          Swal.fire({
            text: data.message,  
            icon: 'success',      
            confirmButtonColor: '#CC4037',       
            confirmButtonText: 'Ok'
          }).then((result) => {
            if (result.isConfirmed) {
          this.ProceedPromt();
        }
      })
          this.getDocument();
          this.getLicensRequest();
          this.getEORequest();
          this.getVoidChequeRequest();
          if(this.checkLicRequested==true){
            Swal.fire({
              text: "Do you want to upload another license(s)?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              cancelButtonText: 'No',
              confirmButtonText: 'Yes'
            }).then((result) => {
              if (result.isConfirmed) {
                this.clickOnRequest(this.duplicatedlicensRequestId);
              }
            })
          }
          this.licensRequestId=null;
          //  this.showlicense=true;
          this.fileenoNameLic = "";
          this.uploadlicenseArray.splice(k, 1);
          this.uploadlicenseArray.push(data.data)
        }, err => {
    
        });
      }else{
        this.user.submitFormService(this.config.getLicDocument, formData).subscribe((data: any) => {
          this.loading = false;
          Swal.fire({
            text: data.message,  
            icon: 'success',      
            confirmButtonColor: '#CC4037',       
            confirmButtonText: 'Ok'
          }).then((result) => {
            if (result.isConfirmed) {
          this.ProceedPromt();
        }
      })
          this.uploadLicensePopup=false;
          this.getDocument();
          this.licensRequestId=null;
          //  this.showlicense=true;
          this.fileenoNameLic = "";
          this.uploadlicenseArray.splice(k, 1);
          this.uploadlicenseArray.push(data.data)
        }, err => {
    
        });
      }
    
  }else{
    this.user.submitFormService1(this.config.OverWriteLicences, formData).subscribe((data: any) => {
      this.loading = false;
      this.licenceId=null;
       this.fileIdlic=null;
       Swal.fire({
        text: data.message,  
        icon: 'success',      
        confirmButtonColor: '#CC4037',       
        confirmButtonText: 'Ok'
      }).then((result) => {
        if (result.isConfirmed) {
      this.ProceedPromt();
    }
  })
      // this.getDocument();
      this.uploadLicensePopup = false;
      this.getDocument();
      // this.showlicense=true;
      this.fileenoNameLic = "";
      this.uploadlicenseArray.splice(k, 1);
      this.uploadlicenseArray.push(data.data)
    }, err => {

    });
  }
    }
    else{
      this.loading = true;
    if(this.licenceId==null){
      if(this.licensRequestId != null){
        this.user.submitFormService(this.config.getLicDocumentRequested, formData).subscribe((data: any) => {
          this.loading = false;
          this.uploadLicensePopup=false;
          Swal.fire({
            text: data.message,  
            icon: 'success',      
            confirmButtonColor: '#CC4037',       
            confirmButtonText: 'Ok'
          }).then((result) => {
            if (result.isConfirmed) {
          this.ProceedPromt();
        }
      })
          this.getAgencyDocuments(this.agencyId,this.leadId);
          this.getLicensRequest()
          this.getEORequest();
          this.getVoidChequeRequest();
          if(this.checkLicRequested==true){
            Swal.fire({
              text: "Do you want to upload another license(s)?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              cancelButtonText: 'No',
              confirmButtonText: 'Yes'
            }).then((result) => {
              if (result.isConfirmed) {
                this.clickOnRequest(this.duplicatedlicensRequestId);
              }
            })
          }
          this.licensRequestId=null;
          //  this.showlicense=true;
          this.fileenoNameLic = "";
          this.uploadlicenseArray.splice(k, 1);
          this.uploadlicenseArray.push(data.data)
        }, err => {
    
        });
      }
      else{
        this.user.submitFormService(this.config.uploadLicensesAgency, formData).subscribe((data: any) => {
          this.loading = false;
          Swal.fire({
            text: data.message,  
            icon: 'success',      
            confirmButtonColor: '#CC4037',       
            confirmButtonText: 'Ok'
          }).then((result) => {
            if (result.isConfirmed) {
          this.ProceedPromt();
        }
      })
          this.uploadLicensePopup=false;
          this.getAgencyDocuments(this.agencyId,this.leadId);
          this.licensRequestId=null;
          //  this.showlicense=true;
          this.fileenoNameLic = "";
          this.uploadlicenseArray.splice(k, 1);
          this.uploadlicenseArray.push(data.data)
        }, err => {
    
        });
      }
   
  }else{
    this.user.submitFormService1(this.config.updateLicenes, formData).subscribe((data: any) => {
      this.loading = false;
      this.licenceId=null;
       this.fileIdlic=null;
       Swal.fire({
        text: data.message,  
        icon: 'success',      
        confirmButtonColor: '#CC4037',       
        confirmButtonText: 'Ok'
      }).then((result) => {
        if (result.isConfirmed) {
      this.ProceedPromt();
    }
  })
      // this.getDocument();
      this.uploadLicensePopup = false;
      this.getAgencyDocuments(this.agencyId,this.leadId);
      // this.showlicense=true;
      this.fileenoNameLic = "";
      this.uploadlicenseArray.splice(k, 1);
      this.uploadlicenseArray.push(data.data)
    }, err => {

    });
  }
    }
  }


  uploadlicensefile(uploadlic, i) {
    var flag = true
    var errormsg = [];
    uploadlic.expiryDateLic = this.DatePipe.transform(uploadlic.expiryDateLic1, 'yyyy-MM-dd');
    uploadlic.effectiveDateLic = this.DatePipe.transform(uploadlic.effectiveDateLic1, 'yyyy-MM-dd');
    //if(uploadlic.showemailErrorMsgone==true){}
    if (!uploadlic.filelicens || uploadlic.filelicens.length <= 0 || uploadlic.showemailErrorMsgone == true) { uploadlic.showemailErrorMsgone = true; flag = false; errormsg.push('Choose File') }
    if (!uploadlic.licenseNumber || uploadlic.licenseNumber.length <= 0) { uploadlic.showlicnErrorMsgone = true; flag = false; errormsg.push('Enter License Number') }
    // if(!uploadlic.licenseType || uploadlic.licenseType.length <= 0){uploadlic.showlictErrorMsgone = true;  flag=false; errormsg.push('License Type')} 
    if (!uploadlic.expiryDateLic || uploadlic.expiryDateLic.length <= 0) { uploadlic.showlicdErrorMsgone = true; flag = false; errormsg.push('Enter Expiry Date') }
    if (!uploadlic.province || uploadlic.province.length <= 0) { uploadlic.showlicpErrorMsgone = true; flag = false; errormsg.push('Select Province') }
    // if(!uploadlic.licenseName || uploadlic.licenseName.length <= 0){uploadlic.showlicnameErrorMsgone=true;  flag=false; errormsg.push('Provience')} 
    if (!uploadlic.effectiveDateLic || uploadlic.effectiveDateLic.length <= 0) { uploadlic.showlicEffectivedErrorMsgone = true; flag = false; errormsg.push('Enter Effective Date') }

    if (flag == true) { 
       if(this.isDocumentRequested==true){
      this.RequestedDocumentAddUpdateLic(uploadlic, i,'LICENSES')      
    }
else if(this.callMgaAPI==false){
      this.FileUploadLic(uploadlic, i);
      }
      else{
        this.documentType="LICENSES"
        this.FileUploadLicMGA(uploadlic, i);
      }
      this.fileenoNameLic=null;
    }
    else {
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replace(",", '<br />');
      Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')
    }
  }
  getLicencesData=[];
  getLicencesDataBroker=[];
  corporateLicType=[];
  MgaLicType=[];
  individualLicType=[];
  showLicTypeonPopup=[];
  getDocument() {
    
    this.callMgaAPI=false
    this.user.getdocuments().pipe()
      .subscribe(
        data => {
          this.MgaLicType=[];
          this.corporateLicType=[];
          this.individualLicType= 
          this.showLicTypeonPopup=[];
          // this.uploadDocStatus = false;
          this.showdocumentsNA=true 
          this.showCompanyDelete=false;  
          this.provienceList = data.data.provinces;
          this.licencesType = data.data.licencesTypes;
          if(data.data.accountDetails.length!=0){
            // this.BankName = data.data.accountDetails[0]?.bankName;
            // this.holderName = data.data.accountDetails[0]?.holderName;
            // this.branchAddress = data.data.accountDetails[0]?.branchAddress;
            this.transitNo = data.data.accountDetails[0]?.transitNumber;
            this.financialInstitutionNo = data.data.accountDetails[0]?.finacialInstitutionNumber;
            this.accountNo = data.data.accountDetails[0]?.accountNumber;
            this.confirmaccountNo = data.data.accountDetails[0]?.accountNumber;
            this.maskaccountNo = data.data.accountDetails[0]?.accountNumber;
            this.eyeIconShowAccountNumber = data.data.accountDetails[0]?.accountNumberPlain;
          }
          else{
            this.transitNo =null;
            this.financialInstitutionNo=null;
            this.accountNo=null;
            this.confirmaccountNo =null;
            this.maskaccountNo =null;
            this.eyeIconShowAccountNumber =null;
          }
          for(let i=0; i<data.data.licencesTypes.length; i++){
            var testOVr = data.data.licencesTypes[i].toLowerCase();
            if (testOVr.slice(-2)=='dr' || testOVr.indexOf('corporate') > -1){
              if(data.data.licencesTypes[i]!=="General 3 - DR"){
              this.corporateLicType.push(data.data.licencesTypes[i])
              this.MgaLicType.push(data.data.licencesTypes[i])
              }
            } 
            if(testOVr.indexOf('corporate') > -1){
              
            }
            else{
              this.individualLicType.push(data.data.licencesTypes[i])
            }
          }
          this.showLicTypeonPopup=this.individualLicType;
          if (data.data.documents != null) {
            if (data.data.documents?.length != 0) {
              this.uploaddocs();
              this.showExpiry = data.data.documents?.expiryDate;
              this.showDocumentName = data.data.documents?.documentName;
              this.showPolicyNumber = data.data.documents?.policyNumber;
              this.finalDocs = data.data.documents;
              this.fileUrlForEno = data.data.documents?.fileUrl;
              this.docId = data.data.documents?.id
              this.docFileId = data.data.documents?.fileId
              this.doctrimtoUrl = data.data.documents?.documentName;
              try{this.doctrimUrl = this.doctrimtoUrl.split('.').pop();}catch{}
              this.checkedDoc = data.data.documents?.status;
              if(this.checkedDoc=="Approved"){
                this.showRemove=true;
              }
              if(this.checkedDoc=="Not Approved"|| this.checkedDoc=="More Information Required"){
                this.showdocumentsNA=false 
              }
              this.checkDocdesc=data.data.documents?.description
              this.isFirstTimeUploadedEOIndividual=data.data.documents?.isFirstTimeUpload;
              this.isEditableDocumentEOIndividual=data.data.documents?.isEditableDocument
            }
          }
          if (data.data.licences.length != 0) {
            this.uploadlicenseArray = [];
            this.getLicencesData=[]
            this.getLicencesDataBroker=[]
            this.showlicense1NA=true
            for (var i = 0; i < data.data.licences.length; i++) {
              var obj = {}
              //this.uploadlicenseArray.push(data.data.licences[i]);
              try{obj["urltreamlic"] = data.data.licences[i].licenseName.split('.').pop();}catch{}
              obj["createdAt"] = data.data.licences[i].createdAt;
              obj["createdBy"] = data.data.licences[i].createdBy;
              obj["description"] = data.data.licences[i].description;
              obj["expiryDate"] = data.data.licences[i].expiryDate;
              obj["effectiveDate"] = data.data.licences[i].effectiveDate;
              obj["fileDownloadUrl"] = data.data.licences[i].fileDownloadUrl;
              obj["fileId"] = data.data.licences[i].fileId;
              obj["fileUrl"] = data.data.licences[i].fileUrl;
              obj["id"] = data.data.licences[i].id;
              obj["lastModifiedBy"] = data.data.licences[i].lastModifiedBy;
              obj["licencesProvince"] = data.data.licences[i].licencesProvince;
              obj["licencesType"] = data.data.licences[i].licencesType;
              obj["licenseName"] = data.data.licences[i].licenseName;
              obj["licensesNumber"] = data.data.licences[i].licensesNumber;
              obj["status"] = data.data.licences[i].status;
              obj["type"] = data.data.licences[i].type;
              obj["updatedAt"] = data.data.licences[i].updatedAt;
              obj["provinceName"] = data.data.licences[i].provinces.provinceName;
              obj["provinceCode"] = data.data.licences[i].provinces.provinceCode;
              obj["isFirstTimeUpload"] = data.data.licences[i].isFirstTimeUpload;
              obj["isEditableDocument"] = data.data.licences[i].isEditableDocument;
              this.uploadlicenseArray.push(obj)
              this.getLicencesData.push(obj)
              this.getLicencesDataBroker.push(obj)
              if(data.data.licences[i].status=="Not Approved"|| data.data.licences[i].status=="More Information Required"){
                this.showlicense1NA=false 
              }
            }
            this.uploadlicstatus()
          }
          else if(this.uploadlicenseArray.length <1){
            this.addFieldValue();
          }
          if (data.data.accountDetails.length != 0) {
            this.uploadvoidchequeArray = [];
            this.showchequeNA=true
            for (var i = 0; i < data.data.accountDetails.length; i++) {
              var obj = {}
              // this.uploadvoidchequeArray.push(data.data.accountDetails[i])
              try{obj["urltreamvoid"] = data.data.accountDetails[i].fileDownloadUrl.split('.').pop();}catch{}
              obj["createdAt"] = data.data.accountDetails[i].createdAt;
              obj["createdBy"] = data.data.accountDetails[i].createdBy;
              obj["description"] = data.data.accountDetails[i].description;
              obj["documentName"] = data.data.accountDetails[i].documentName;
              obj["fileDownloadUrl"] = data.data.accountDetails[i].fileDownloadUrl;
              obj["fileId"] = data.data.accountDetails[i].fileId;
              obj["fileUrl"] = data.data.accountDetails[i].fileUrl;
              obj["id"] = data.data.accountDetails[i].id;
              obj["lastModifiedBy"] = data.data.accountDetails[i].lastModifiedBy;
              obj["status"] = data.data.accountDetails[i].status;
              obj["type"] = data.data.accountDetails[i].type;
              obj["updatedAt"] = data.data.accountDetails[i].updatedAt;
              obj["isFirstTimeUpload"] = data.data.accountDetails[i].isFirstTimeUpload;
              obj["isEditableDocument"] = data.data.accountDetails[i].isEditableDocument;
              this.uploadvoidchequeArray.push(obj)
              if(data.data.accountDetails[i].status=="Not Approved"|| data.data.accountDetails[i].status=="More Information Required"){
                this.showchequeNA=false
              }
            }
            this.uploadvoidstatus();
          }
          else if(this.uploadvoidchequeArray.length <1){
            this.addFieldValuecheque();
          }
          if(data.data.accountDetails?.length != 0 && data.data.documents?.length != 0 &&
            data.data.licences.length != 0){
              this.uploadDocStatus = true;
            }
            else{
              this.uploadDocStatus = false;
            }
            if(this.showbtn==true)
            {this.ProceedPromt();}
        }, error => {
          //  if(this.baseservice.handleError(error)){
          //handle Exception from Server 404,401
          if (error.status == 400 || error.status == 417) {
            this.error = error.error.data;

          }
          else {

            this.error = "Something went wrong.Please try again later.";
          }

        }, () => { });

  }
  proceed() {
    this.DocmoreInfoReq(this.leadId);
    setTimeout(() => {
      this.router.navigate(['/dashboard/contract-sign'])
        .then(() => {
          window.location.reload();
        });
    }, 50);
    // window.location.reload();
  }
  confirmYes:boolean=false;
  uploadAllDocument() {
    //debugger
    this.showforProceed = false;
    // if(this.commissionsTo!="BROKER" || this.commissionsTo!='Broker'){
    if(this.commissionsTo!='Broker'){
      this.showcheque=true
    }
   
    if(this.Type=='General Agent'){
      this.showdocuments=true
      this.showcheque=true
      this.showdocumentsNA=true
this.showchequeNA=true
this.showdocumentsAgencyNA=true
this.showchequeAgencyNA=true

    }
   
    if(this.Type=='General Agency Rep'){
      this.showdocuments=true
      this.showcheque=true
      this.showdocumentsNA=true
this.showchequeNA=true
// this.showdocumentsAgencyNA=true
this.showchequeAgencyNA=true

    }
    if(this.Type=='Travel Agency Rep'){
      this.showdocuments=true
      this.showcheque=true
      this.showdocumentsNA=true
this.showchequeNA=true
this.showdocumentsAgency=true
this.showdocumentsAgencyNA=true
this.showchequeAgencyNA=true

    }
    if(this.Type=='Travel Agent'){
      if(this.residentProvince!=='NS'){
        this.showlicense1=true
        this.showlicense1NA=true
        this.showlicenseAgencyNA=true
      }
      this.showdocuments=true
      this.showcheque=true      
      this.showdocumentsNA=true  
   this.showchequeNA=true
   this.showdocumentsAgencyNA=true   
   this.showchequeAgencyNA=true
    }

    if(this.showCompany == false && this.showMgaTab==false){
      // if(this.checkedDoc=="Not Approved"|| this.checkedDoc=="More Information Required"){
      //   if(data.data.licences[i].status=="Not Approved"|| data.data.licences[i].status=="More Information Required"){
      //     if (this.uploadvoidchequeArray.length != 0) {
            
      //       for (var i = 0; i < this.uploadvoidchequeArray.length; i++) {
      //           if(this.uploadvoidchequeArray[i].status=="Not Approved"|| this.uploadvoidchequeArray[i].status=="More Information Required"){
      //          }
      //        }
      //     }
      //   }
        
      // }
      
    this.residentLicPresent=false
    for(let i=0; i<this.uploadlicenseArray.length; i++){
    if(this.uploadlicenseArray[i].provinceCode==this.residentProvince || this.uploadlicenseArray[i].province==this.residentProvince){

      this.residentLicPresent=true
    }
  }
  if(this.residentLicPresent==true){
      this.showdocumentsNA
   this.showlicense1NA
   this.showchequeNA
   this.showdocumentsAgencyNA
   this.showlicenseAgencyNA
   this.showchequeAgencyNA
   if (this.showdocumentsNA && this.showlicense1NA && this.showchequeNA){
    if (this.showdocuments && this.showlicense1 && this.showcheque) {
      if(this.Type=='Travel Agent'){
        this.user.saveDocument(this.leadId).pipe()
        .subscribe(
          data => {
            if (data.status == true) {
              if(this.uploadlicenseArray[0]?.licensesNumber!=undefined || this.docFileId!=undefined){
                this.showdocumentModal = true;
                this.uploadDocStatus = true;
              }else{
                this.showdocumentModal = false;
                this.proceed();
              }
            } else {
              Swal.fire("Something went wrong. please try again later.")
            }
          }, error => {
            //  if(this.baseservice.handleError(error)){
            //handle Exception from Server 404,401
            if (error == "Bad Request") {
              Swal.fire("Bad Request. please try again")
            }
            else {
              Swal.fire("Something went wrong. Please check and try again.")
            }

          }, () => { });
      }else{
      Swal.fire({
        text: "Have you uploaded an insurance license for each province in which you are licensed?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.isConfirmed) {
          this.user.saveDocument(this.leadId).pipe()
          .subscribe(
            data => {
              if (data.status == true) {
                this.showdocumentModal = true;
                this.uploadDocStatus = true;
              } else {
                Swal.fire("Something went wrong. please try again later.")
              }
            }, error => {
              //  if(this.baseservice.handleError(error)){
              //handle Exception from Server 404,401
              if (error == "Bad Request") {
                Swal.fire("Bad Request. please try again")
              }
              else {
                Swal.fire("Something went wrong. Please check and try again.")
              }
  
            }, () => { });
        }
      })
      }
    }
    // if(this.showdocuments == true && this.uploadlicenseArray.length != 0 && this.uploadvoidchequeArray.length != 0){
    //   // this.uploadDocStatus = true;
    // }
    else {
      Swal.fire("","Please upload all required documents to continue.",'warning')
    }
  }
    else {
      Swal.fire("","Please upload all the document(s) or complete any pending action(s).",'warning')
    }
  }else{
    Swal.fire(
      {
        icon: "warning",
        text: "You must provide us with a copy of your “resident province” license to proceed with the sign up process.",
        footer: '<span style="font-size:16px;color:#CC4037">“Resident Province”- The province where you currently reside and operate out of.</span>'
      }
    );
  }
  }else if(this.showCompany == true && this.showMgaTab==false){
    this.residentLicPresent=false
    for(let i=0; i<this.getLicencesDataBroker.length; i++){
    if(this.getLicencesDataBroker[i].provinceCode==this.residentProvince){

      this.residentLicPresent=true
    }
  }
  if(this.residentLicPresent==true){
    // this.callIndividualDoc();
    // this.callAgencyDoc();
        this.showcheque=true
        this.showchequeNA=true;
      if (this.showdocumentsNA && this.showlicense1NA && this.showchequeNA && this.showdocumentsAgencyNA && this.showlicenseAgencyNA && this.showchequeAgencyNA){
    if (this.showdocuments && this.showlicense1 && this.showcheque && this.showdocumentsAgency && this.showlicenseAgency && this.showchequeAgency) {
      // if(this.showCompany == true){
      //   this.callAgencyDoc();
      // }
      // if (this.showdocuments) {
        Swal.fire({
          text: "Have you uploaded an insurance license for each province in which you are licensed?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          cancelButtonText: 'No',
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result.isConfirmed) {
            this.user.saveDocument(this.leadId).pipe()
        .subscribe(
          data => {
            if (data.status == true) {
              this.showdocumentModal = true;
              this.uploadDocStatus = true;
            } else {
              Swal.fire("Something went wrong. please try again later.")
            }
          }, error => {
            //  if(this.baseservice.handleError(error)){
            //handle Exception from Server 404,401
            if (error == "Bad Request") {
              Swal.fire("Bad Request. please try again")
            }
            else {
              Swal.fire("Something went wrong. Please check and try again.")
            }

          }, () => { });
          }
        })
    }
    // if(this.showdocuments == true && this.uploadlicenseArray.length != 0 && this.uploadvoidchequeArray.length != 0){
    //   // this.uploadDocStatus = true;
    // }
    else {
      // Swal.fire("","Please upload all required documents to continue.",'warning')
      
      if (!this.showdocuments || !this.showlicense1){
        this.callIndividualDoc();
        
        this.openTabs2(0);
        this.tabs2[0].active2;
        
    
      }
      if(!this.showdocumentsAgency || !this.showlicenseAgency ){
        //this.companydocmodal = true;
        this.callAgencyDoc();
        this.openTabs2(1);
        this.tabs2[1].active2;
        
      }
      if( !this.showchequeAgency ){
        this.callAgencyDoc();

        //this.companydocmodal = true;
        this.callAgencyDoc();
        this.openTabs2(1);
        this.tabs2[1].active2;
      }
      setTimeout(() => 
      {
        if (!this.showdocuments || !this.showlicense1 || !this.showcheque || !this.showdocumentsAgency || !this.showlicenseAgency || !this.showchequeAgency){
          Swal.fire("","Please upload all required 'Individual' and 'Company' documents to continue.",'warning');
        }
      },
      2000);
    }
  }
    else{
      Swal.fire("","Please upload all the document(s) or complete any pending action(s).",'warning')
    }
  }
  else{
    Swal.fire(
      {
        icon: "warning",
        text: "You must provide us with a copy of your “resident province” license to proceed with the sign up process.",
        footer: '<span style="font-size:16px;color:#CC4037">“Resident Province”- The province where you currently reside and operate out of.</span>'
      }
    );
  }
  }
  else{
    //debugger
    this.residentLicPresent=false
    for(let i=0; i<this.getLicencesDataBroker.length; i++){
    if(this.getLicencesDataBroker[i].provinceCode==this.residentProvince || this.uploadlicenseArray[i].province==this.residentProvince){

      this.residentLicPresent=true
    }
  }
  if(this.residentLicPresent==true){
this.showcheque=true
this.showchequeNA=true;

if (this.showdocumentsNA && this.showlicense1NA && this.showchequeNA && this.showdocumentsMgaNA && this.showlicenseMgaNA && this.showchequeMgaNA){
if (this.showdocuments && this.showlicense1 && this.showcheque  && this.showdocumentsMGA && this.showlicenseMGA && this.showchequeMGA) {
// if(this.showCompany == true){
//   this.callAgencyDoc();
// }
// if (this.showdocuments) {
Swal.fire({
  text: "Have you uploaded an insurance license for each province in which you are licensed?",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
  cancelButtonText: 'No',
  confirmButtonText: 'Yes'
}).then((result) => {
  if (result.isConfirmed) {
    this.user.saveDocument(this.leadId).pipe()
.subscribe(
  data => {
    if (data.status == true) {
      this.showdocumentModal = true;
      this.uploadDocStatus = true;
    } else {
      Swal.fire("Something went wrong. please try again later.")
    }
  }, error => {
    //  if(this.baseservice.handleError(error)){
    //handle Exception from Server 404,401
    if (error == "Bad Request") {
      Swal.fire("Bad Request. please try again")
    }
    else {
      Swal.fire("Something went wrong. Please check and try again.")
    }

  }, () => { });
  }
})
}
// if(this.showdocuments == true && this.uploadlicenseArray.length != 0 && this.uploadvoidchequeArray.length != 0){
//   // this.uploadDocStatus = true;
// }
else {
// Swal.fire("","Please upload all required documents to continue.",'warning')

if (!this.showdocuments || !this.showlicense1){
this.callIndividualDoc();

this.openTabs2(0);
this.tabs2[0].active2;


}

if( !this.showchequeMGA  || this.showdocumentsMGA || this.showlicenseMGA){
this.callMgaDoc();

//this.companydocmodal = true;
// this.callAgencyDoc();
this.openTabs2(2);
this.tabs2[2].active2;
}
setTimeout(() => 
{
if (!this.showdocuments || !this.showlicense1 || !this.showcheque || !this.showdocumentsAgency || !this.showlicenseAgency || !this.showchequeAgency || !this.showdocumentsMGA || !this.showlicenseMGA || !this.showchequeMGA){
  Swal.fire("","Please upload all required 'Individual' and 'Company' documents to continue.",'warning');
}
},
2000);
}
}
else{
Swal.fire("","Please upload all the document(s) or complete any pending action(s).",'warning')
}
}
else{
  Swal.fire(
    {
      icon: "warning",
      text: "You must provide us with a copy of your “resident province” license to proceed with the sign up process.",
      footer: '<span style="font-size:16px;color:#CC4037">“Resident Province”- The province where you currently reside and operate out of.</span>'
    }
  );
}
  }

  }
  // Void Cheque
  fileExtensionVC: any;
  fileExtensionErrorVC: boolean = false;
  fileExtensionMessageVC: any;
  voidfile: File=null;
  voidSizeCheck: boolean=false;
  FileSelect1(event, i) {
    
    if (event.target.files.length > 0) {
    //
    this.fileenoName1 = ""
    this.voidfile = event.target.files[i];
    if(this.voidfile.size>4194304){
      this.voidSizeCheck=true;
      Swal.fire({
        icon: 'error',
        text: 'Please upload the filesize less than 4MB',
      })
    }else{
      this.showemailErrorMsg1 = false;
      this.voidSizeCheck=false;
    }

    
      this.FileDataList1 = event.target.files;
      this.fileenoName1 = this.FileDataList1[0].name;

      this.fileExtensionVC = this.fileenoName1.split('.').pop();
      if (this.isInArray(this.acceptedExtensions, this.fileExtensionVC)) {
        this.fileExtensionErrorVC = false;
        this.fileExtensionMessageVC = ""

        this.uploadvoidchequeArray[i].showemailErrorMsg1 = this.fileExtensionErrorVC
        this.fileenoName1 = this.FileDataList1[0].name;
      } else {
        this.fileExtensionMessageVC = "Invalid file type, Please select file with allowed file types: .pdf, .png , .jpeg or .docx "
        this.fileExtensionErrorVC = true;
        this.uploadvoidchequeArray[i].showemailErrorMsg1 = this.fileExtensionErrorVC
        this.fileenoName1 = this.fileExtensionMessageVC

      }

    } else {
      // this.uploadvoidchequeArray[i].showemailErrorMsg1 = false;
      // this.fileenoName1 = ""
      this.uploadvoidchequeArray[i].fileeno1=this.fileenoName1
    }
  }
  isUpdateClick:boolean=false
  abc(){
    this.isUpdateClick=true
  }
  uploadEno1(item, i) {
    //
    
    var flag = true
    var errormsg = [];
    // banking info
    try{this.transitNo=this.transitNo.trim()}catch{}
    try{this.financialInstitutionNo=this.financialInstitutionNo.trim()}catch{}
    try{this.accountNo=this.accountNo.trim()}catch{}
    try{this.confirmaccountNo=this.confirmaccountNo.trim()}catch{}
    // if(this.form2.secondCtrl.value ==''){flag=false; this.declarationErrorFlag=true}else{this.declarationErrorFlag=false}
    
    
    
    // end banking info
      // if(this.allowUser == true){
      //   if (this.btnPopupName == "Confirm"){
      //     if(this.accountNo==this.confirmaccountNo){
      //       if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false;}
      //       if ( !this.transitNo || this.transitNo.length < 3 ) { this.transitNoErrMsg=true;flag = false;}
      //       if ( !this.financialInstitutionNo  || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false;}
      //       if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false;}
      //       if (!item.fileId || item.fileId.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
      //   }
      //   else{
      //     flag=false
      //   }
      // }
      // } else{
      //   this.bankInfoErrmsg = true;
      //   flag = false;
      // }
   
    // if(this.allowUser == true){
      if(this.btnPopupName == "Save"){
        if(this.accountNo!==this.confirmaccountNo){flag = false; errormsg.push('Account Number and Confirm Account Number does not match.');}
          if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false; errormsg.push('Enter valid 3 digits Bank Number.')}
          if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number.')}
          if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number.')}
          if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false; errormsg.push('Enter valid Confirm Account Number.')}
        if ( this.allowUser == false) { this.bankInfoErrmsg=true; flag = false; errormsg.push('Please click the acknowledgement checkbox.')}
        if(item.fileId!==undefined && item.fileId!==null){
          if (!item.fileId || item.fileId.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
        }else{
        if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
    }
    //    }
    // else{
    //   flag=false;
    //   if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false; errormsg.push('Enter valid 3 digits Bank Number.')}
    //   if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number.')}
    //   if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number.')}
    //   if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false; errormsg.push('Enter valid Confirm Account Number.')}
    //   if ( this.allowUser == false) { this.bankInfoErrmsg=true;flag = false; errormsg.push('Please click the acknowledgement checkbox.')}
    //   errormsg.push('Account Number and Confirm Account Number does not match.');
    // }
    if(this.bankinfoChecked==true){
      this.bankInfoErrmsg=false
    }else{
      this.bankInfoErrmsg=true;
      flag = false;
    }
  }else{
    flag = false;
    // this.bankInfoErrmsg = true;
  }
    // }else{
    //   flag = false;
    //   this.bankInfoErrmsg = true;
    //   if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false; errormsg.push('Enter valid 3 digits Bank Number')}
    //   if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number')}
    //   if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number')}
    //   if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false; errormsg.push('Enter valid Confirm Account Number')}
    //   if ( !this.bankinfoChecked) { this.bankInfoErrmsg=true;flag = false; errormsg.push('Please click the acknowledgement checkbox.')}
    //   this.msg = errormsg.toString();
    //   this.msgfinal = this.msg.replace(",", '<br />');
    //   Swal.fire("", "Please complete the following mandatory field(s):"  +","+"<br>" + this.msgfinal, 'warning')
    // }
   
    if ( this.voidSizeCheck==true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Please upload the filesize less than 4MB')}
    // if(!this.expiryDate || this.expiryDate.length <= 0){this.showdateErrorMsg = true;  flag=false; errormsg.push('Date')} 
    // }
    // if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
    // if ( this.voidSizeCheck==true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Please upload the filesize less than 4MB')}
    if (flag == true) {
      if(this.isDocumentRequested==true){
        this.RequestedDocumentAddUpdateVoid(item, i,'VOID_CHEQUE')      
      }
else if(this.callMgaAPI==false){
      this.FileUpload1(item, i);
    }else{
      this.documentType="VOID_CHEQUE"
      this.FileUploadVoidMGA(item, i);
    }
    }else {
      if(this.bankinfoChecked==true){
        this.bankInfoErrmsg=false
      }else{
        this.bankInfoErrmsg=true;
        flag = false;
      }
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replaceAll(",", '<br />');
      Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')

    }
  }
  
  FileUpload1(item, k) {
    //
      
        if(this.FileDataList1!=undefined){
        for (var i = 0; i < this.FileDataList1.length; i++) {
          this.productPhotofile1 = this.FileDataList1[i];
          if (this.productPhotofile1 != null) {
            const formData = new FormData();
            formData.append('file', this.productPhotofile1);
            formData.append('accountNumber', this.accountNo);
            formData.append('confirmaccountNo', this.confirmaccountNo);
            formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
            formData.append('transitNumber', this.transitNo);
            var data = sessionStorage.getItem('leadId')
            formData.append('leadId', data);
            //  this.fileData=formData
            if(this.fileIdvoid!=null || this.voidchequeId!=null){
              formData.append('fileId', this.fileIdvoid);
              formData.append('voidChequeId', this.voidchequeId);
            }
            if(this.showCompanyDelete==true){
             formData.append('agencyId ', this.agencyId);
           }
            this.uploadImages1(formData, k)
          }
        }
        
      }else{
          const formData = new FormData();
            // formData.append('file', this.productPhotofile1);
            formData.append('accountNumber', this.accountNo);
            formData.append('confirmaccountNo', this.confirmaccountNo);
            formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
            formData.append('transitNumber', this.transitNo);
            var data = sessionStorage.getItem('leadId')
            formData.append('leadId', data);
            //  this.fileData=formData
            if(this.fileIdvoid!=null || this.voidchequeId!=null){
              formData.append('fileId', this.fileIdvoid);
              formData.append('voidChequeId', this.voidchequeId);
            }
            if(this.showCompanyDelete==true){
             formData.append('agencyId ', this.agencyId);
           }
            this.uploadImages1(formData, k)
    }
    // else{
    //   for (var i = 0; i < this.FileDataList1.length; i++) {
    //     this.productPhotofile1 = this.FileDataList1[i];
    //     if (this.productPhotofile1 != null) {
    //       const formData = new FormData();
    //       formData.append('file', this.productPhotofile1);
    //       var data = sessionStorage.getItem('leadId')
    //       formData.append('leadId', data);
    //       //  this.fileData=formData
    //       if(this.fileIdvoid!=null || this.voidchequeId!=null){
    //         formData.append('fileId', this.fileIdvoid);
    //         formData.append('voidChequeId', this.voidchequeId);
    //       }
    //       if(this.showCompanyDelete==true){
    //        formData.append('agencyId ', this.agencyId);
    //      }
    //       this.uploadImages1(formData, k)
    //     }
  
    //   }
    // }
  }
  fileIdvoid: any
  voidchequeId: any;
  overwriteVoid(voidval){
    //
    this.fileIdvoid=voidval.fileId;
    this.voidchequeId=voidval.id;
    this.isOverWriteEO=true
    this.voidchequeId=voidval.id;
    var obj={
      "fileeno1":voidval.fileUrl,
       }
      this.uploadvoidchequeArray=[]
      this.uploadvoidchequeArray.push(voidval)
       this.fileenoName1=voidval.documentName
  }
  async uploadImages1(formData: FormData, k) {
    //
    if(this.showCompanyDelete==false){
    this.loading = true;
    if (this.fileIdvoid==null || this.voidchequeId==null){
      this.user.submitFormService(this.config.uploadVoidCheque, formData).subscribe((data: any) => {
    
        this.finalDocs1 = data.data;
        this.loading = false;
        Swal.fire({
          text: data.message,  
          icon: 'success',      
          confirmButtonColor: '#CC4037',       
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.isConfirmed) {
        this.ProceedPromt();
      }
    })
        this.showcheque=true;
        this.BankInfo=false
        this.uploadVoidChequePopup=false;
        this.BankInfo =false;
        this.getDocument();
        this.showDocumentName1 = data.data.documentName;
        this.fileenoName1 = ""
        this.uploadvoidchequeArray.splice(k, 1);
        this.uploadvoidchequeArray.push(data.data)
        this.bankinfoChecked=false
      }, err => {
  
      });
    }else{
      this.user.submitFormService1(this.config.OverWriteVoidCheque, formData).subscribe((data: any) => {
        this.finalDocs1 = data.data;
        this.loading = false;
        this.BankInfo=false
        this.uploadVoidChequePopup = false;
        if (data.status == true){
          Swal.fire({
            text: data.message,  
            icon: 'success',      
            confirmButtonColor: '#CC4037',       
            confirmButtonText: 'Ok'
          }).then((result) => {
            if (result.isConfirmed) {
          this.ProceedPromt();
        }
      })
          // this.showcheque=true;
        } else {
          Swal.fire('', data.message, 'error');
        }
        this.getDocument();
        this.showDocumentName1 = data.data.documentName;
        this.fileenoName1 = ""
        this.uploadvoidchequeArray.splice(k, 1);
        this.uploadvoidchequeArray.push(data.data)

      }, err => {

      });
    } 
  }
  else{
    this.loading = true;
    if(this.fileIdvoid==null || this.voidchequeId==null){
      this.user.submitFormService(this.config.uploadVoidAgency, formData).subscribe((data: any) => {
  
        this.finalDocs1 = data.data;
        this.loading = false;
        Swal.fire({
          text: data.message,  
          icon: 'success',      
          confirmButtonColor: '#CC4037',       
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.isConfirmed) {
        this.ProceedPromt();
      }
    })
        this.showcheque=true;
        this.BankInfo=false;
        this.uploadVoidChequePopup=false;
        this.getAgencyDocuments(this.agencyId,this.leadId);
  
        this.showDocumentName1 = data.data.documentName;
        this.fileenoName1 = ""
        this.uploadvoidchequeArray.splice(k, 1);
        this.uploadvoidchequeArray.push(data.data)
  
      }, err => {
  
      });
    }else{
      this.user.submitFormService1(this.config.updateVoidAgency, formData).subscribe((data: any) => {

        this.finalDocs1 = data.data;
        this.loading = false;
        this.uploadVoidChequePopup=false;
        // this.uploadVoidChequePopup = !this.uploadVoidChequePopup;
        Swal.fire({
          text: data.message,  
          icon: 'success',      
          confirmButtonColor: '#CC4037',       
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.isConfirmed) {
        this.ProceedPromt();
      }
    })
        this.getAgencyDocuments(this.agencyId,this.leadId);
        this.showDocumentName1 = data.data.documentName;
        this.fileenoName1 = ""
        this.uploadvoidchequeArray.splice(k, 1);
        this.uploadvoidchequeArray.push(data.data)
  
      }, err => {
  
      });
    }
  }
  }
  uploaddocs1() {
    this.showdocuments1 = true;
  }

  removedocs1(i, id) {
    // console.log(id)
    if(this.showCompanyDelete==false && this.callMgaAPI==false){
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.user.deleteVoidCheck(id).pipe()
        .subscribe(
          data => {
            if (data.success == true) {
              Swal.fire('Deleted!',
              'Your Void Cheque has been removed successfully.',
              'success');
              this.showcheque=false;
              this.transitNo = null;
              this.financialInstitutionNo = null;
              this.accountNo = null;
              this.confirmaccountNo = null;
              this.btnPopupName == "Save";
              this.fileIdvoid = null; 
              this.voidchequeId = null;
              this.bankinfoChecked = false;
              this.fileenoName1 = "";
              this.getDocumentDeleteCheck();
              if (this.uploadvoidchequeArray.length == 0) {
                this.uploadvoidchequeArray.push(this.newAttributenext)
                this.newAttributenext = {};
              }
              // this.uploadvoidchequeArray.splice(i, 1);
            }
          }, error => {
  
            if (error.status == 400 || error.status == 417) {
              this.error = error.error.data;
            }
            else {
  
              this.error = "Something went wrong";
            }
  
          }, () => { });
      }
    })
    }else if(this.showCompanyDelete==true && this.callMgaAPI==false){
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.user.deleteVoidCheckAgency(id).pipe()
          .subscribe(
            data => {
              if (data.success == true) {
                Swal.fire('Deleted!',
                'Your Void Cheque has been removed successfully.',
                'success');
                this.showchequeAgency=false;
                this.transitNo = null;
                this.financialInstitutionNo = null;
                this.accountNo = null;
                this.confirmaccountNo = null;
                this.fileIdvoid = null; 
                this.voidchequeId = null;
                this.bankinfoChecked = false;
                this.fileenoName1 = "";
                this.getAgencyDocumentsForDelete(this.agencyId,this.leadId);
                this.openTabs2(1)
                if (this.uploadvoidchequeArray.length == 0) {
                  this.uploadvoidchequeArray.push(this.newAttributenext)
                  this.newAttributenext = {};
                }
                // this.uploadvoidchequeArray.splice(i, 1);
              }
            }, error => {
    
              if (error.status == 400 || error.status == 417) {
                this.error = error.error.data;
              }
              else {
    
                this.error = "Something went wrong";
              }
    
            }, () => { });
        }
      })
    }
    else{
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.user.deletedocumentMga(id).pipe()
          .subscribe(
            data => {
              if (data.success == true) {
                Swal.fire('Deleted!',
                'Your Void Cheque has been removed successfully.',
                'success');
                this.showchequeAgency=false;
                this.getMGADocuments()
                this.openTabs2(2)
                this.callMgaAPI==true
                if (this.uploadvoidchequeArray.length == 0) {
                  this.uploadvoidchequeArray.push(this.newAttributenext)
                  this.newAttributenext = {};
                }
                // this.uploadvoidchequeArray.splice(i, 1);
              }
            }, error => {
    
              if (error.status == 400 || error.status == 417) {
                this.error = error.error.data;
              }
              else {
    
                this.error = "Something went wrong";
              }
    
            }, () => { });
        }
      })
    }

  }
  removeVoid(i,) {
    this.uploadvoidchequeArray.splice(i, 1);
  }
 
  agencyDocApiError:boolean=false;
  getAgencyDocuments(agencyId,leadId){
    //this.agencyDocApiError=true;
    
    if(this.agencyId!=undefined){
      try{
    this.user.getAgencydocuments(agencyId,leadId).pipe()
    .subscribe(
      data => {
      
        this.expiryDate1=null;
        this.effectiveDate1=null;
        this.agencyDocApiError=false;
        this.showCompanyDelete=true;
        this.uploadlicenseArray = [];
        this.getLicencesData=[]
        this.uploadvoidchequeArray = [];
        // this.provienceList = data.data.provinces;
        // this.licencesType = data.data.licencesTypes
        if(data.data.accountDetails.length!=0){
          this.transitNo = data.data.accountDetails[0]?.transitNumber;
          this.financialInstitutionNo = data.data.accountDetails[0]?.finacialInstitutionNumber;
          this.accountNo = data.data.accountDetails[0]?.accountNumber;
          this.confirmaccountNo = data.data.accountDetails[0]?.accountNumber;
          this.maskaccountNo = data.data.accountDetails[0]?.accountNumber;
          this.eyeIconShowAccountNumber = data.data.accountDetails[0]?.accountNumberPlain;
        }
        else{
          this.transitNo =null;
          this.financialInstitutionNo=null;
          this.accountNo=null;
          this.confirmaccountNo =null;
          this.maskaccountNo =null;
          this.eyeIconShowAccountNumber =null;
        }
        if (data.data.documents != null) {
          this.showdocumentsAgencyNA=true
          if (data.data.documents?.length != 0) {
            this.uploaddocsAgency();
            this.showExpiry = data.data.documents?.expiryDate;
            this.showDocumentName = data.data.documents?.documentName;
            this.showPolicyNumber = data.data.documents?.policyNumber;
            this.finalDocs = data.data.documents;
            this.fileUrlForEno = data.data.documents?.fileUrl;
            this.docId = data.data.documents?.id
            this.docFileId = data.data.documents?.fileId
            this.doctrimtoUrl = data.data.documents?.documentName;
            try{this.doctrimUrl = this.doctrimtoUrl.split('.').pop();}catch{}
            this.checkedDoc = data.data.documents?.status;
            this.isFirstTimeUploadedEOCompany=data.data.documents?.isFirstTimeUpload;
            this.isEditableDocumentEOCompany=data.data.documents?.isEditableDocument;
            if(this.checkedDoc=="Approved"){
              this.showRemove1=true;
            }
            if(this.checkedDoc=="Not Approved"|| this.checkedDoc=="More Information Required"){
              this.showdocumentsAgencyNA=false 
              
            }
            this.checkDocdesc=data.data.documents?.description
            
          }
        }

        if (data.data.licences.length != 0) {
          this.showlicenseAgencyNA=true
          this.uploadlicstatusAgency()
          for (var i = 0; i < data.data.licences.length; i++) {
            var obj = {}
            //this.uploadlicenseArray.push(data.data.licences[i]);
            try{obj["urltreamlic"] = data.data.licences[i].licenseName.split('.').pop();}catch{}
            obj["createdAt"] = data.data.licences[i].createdAt;
            obj["createdBy"] = data.data.licences[i].createdBy;
            obj["description"] = data.data.licences[i].description;
            obj["expiryDate"] = data.data.licences[i].expiryDate;
            obj["effectiveDate"] = data.data.licences[i].effectiveDate;
            obj["fileDownloadUrl"] = data.data.licences[i].fileDownloadUrl;
            obj["fileId"] = data.data.licences[i].fileId;
            obj["fileUrl"] = data.data.licences[i].fileUrl;
            obj["id"] = data.data.licences[i].id;
            obj["lastModifiedBy"] = data.data.licences[i].lastModifiedBy;
            obj["licencesProvince"] = data.data.licences[i].licencesProvince;
            obj["licencesType"] = data.data.licences[i].licencesType;
            obj["licenseName"] = data.data.licences[i].licenseName;
            obj["licensesNumber"] = data.data.licences[i].licensesNumber;
            obj["status"] = data.data.licences[i].status;
            obj["type"] = data.data.licences[i].type;
            obj["updatedAt"] = data.data.licences[i].updatedAt;
            obj["provinceName"] = data.data.licences[i].provinces.provinceName;
            obj["provinceCode"] = data.data.licences[i].provinces.provinceCode;
            obj["isFirstTimeUpload"] = data.data.licences[i].isFirstTimeUpload;
            obj["isEditableDocument"] = data.data.licences[i].isEditableDocument;
            if(data.data.licences[i].status=="Not Approved"|| data.data.licences[i].status=="More Information Required"){
              this.showlicenseAgencyNA=false 
              
            }
            this.uploadlicenseArray.push(obj)
            this.getLicencesData.push(obj)
          }
          
         
        }
        else if(this.uploadlicenseArray.length<1){
          this.addFieldValue();
        }
        if (data.data.accountDetails.length != 0) {
          this.uploadvoidchequeArray = [];
          this.showchequeAgencyNA=true
          this.uploadvoidstatusAgency();
          for (var i = 0; i < data.data.accountDetails.length; i++) {
            var obj = {}
            // this.uploadvoidchequeArray.push(data.data.accountDetails[i])
            try{obj["urltreamvoid"] = data.data.accountDetails[i].fileDownloadUrl.split('.').pop();}catch{}
            obj["createdAt"] = data.data.accountDetails[i].createdAt;
            obj["createdBy"] = data.data.accountDetails[i].createdBy;
            obj["description"] = data.data.accountDetails[i].description;
            obj["documentName"] = data.data.accountDetails[i].documentName;
            obj["fileDownloadUrl"] = data.data.accountDetails[i].fileDownloadUrl;
            obj["fileId"] = data.data.accountDetails[i].fileId;
            obj["fileUrl"] = data.data.accountDetails[i].fileUrl;
            obj["id"] = data.data.accountDetails[i].id;
            obj["lastModifiedBy"] = data.data.accountDetails[i].lastModifiedBy;
            obj["status"] = data.data.accountDetails[i].status;
            obj["type"] = data.data.accountDetails[i].type;
            obj["updatedAt"] = data.data.accountDetails[i].updatedAt;
            obj["isFirstTimeUpload"] = data.data.accountDetails[i].isFirstTimeUpload;
            obj["isEditableDocument"] = data.data.accountDetails[i].isEditableDocument;
            this.uploadvoidchequeArray.push(obj)
            if(data.data.accountDetails[i].status=="Not Approved"|| data.data.accountDetails[i].status=="More Information Required"){
              this.showchequeAgencyNA=false 
            }
                 
        
          }
          
          
        }
        else if(this.uploadvoidchequeArray.length<1){
          this.addFieldValuecheque();
        }
        if(data.data.accountDetails?.length != 0 && data.data.documents?.length != 0 &&
          data.data.licences.length != 0){
            this.uploadDocStatus = true;
          }
          else{
            this.uploadDocStatus = false;
          }
 
      }, error => {
        //  if(this.baseservice.handleError(error)){
        //handle Exception from Server 404,401
      
      }, () => { });
    }
    catch{
      this.uploadvoidchequeArray = [];
      this.uploadlicenseArray = [];
      this.getLicencesData=[];
    }
  }
  
      else{
        this.uploadvoidchequeArray = [];
        this.uploadlicenseArray = [];
        this.getLicencesData=[];
        this.addFieldValue();
        //this.addFieldValuecheque();
          }
          
  }

  
  uploadEnoAgency() {
    var flag = true
    var errormsg = [];
    this.expiryDate = this.DatePipe.transform(this.expiryDate1, 'yyyy-MM-dd');
    this.effectiveDate = this.DatePipe.transform(this.expiryDate1, 'yyyy-MM-dd');
    if (!this.fileeno || this.fileeno.length <= 0 || this.showemailErrorMsg == true) { this.showemailErrorMsg = true; flag = false; errormsg.push('Choose File') }
    if (!this.expiryDate || this.expiryDate.length <= 0) { this.showdateErrorMsg = true; flag = false; errormsg.push('Enter Expiry Date') }
    if (!this.policyNumber || this.policyNumber.length <= 0) { this.showdateErrorMsg = true; flag = false; errormsg.push('Enter E&O Policy Number') }
    if (this.enoSizeCheck==true) { this.showemailErrorMsg = true; flag = false; errormsg.push('Please upload the filesize less than 4MB') }
    if (!this.effectiveDate || this.effectiveDate.length <= 0) { this.showEffectivedateErrorMsg = true; flag = false; errormsg.push('Enter Effective Date') }

    
    if (flag == true) {

      this.FileUploadAgency();
    }
    else {
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replace(",", '<br />');
      Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')

    }
  }
  FileUploadAgency() {
    for (var i = 0; i < this.FileDataList.length; i++) {
      this.productPhotofile = this.FileDataList[i];
      if (this.productPhotofile != null) {
        const formData = new FormData();
        formData.append('file', this.productPhotofile);
        formData.append('expiryDate', this.expiryDate);
        formData.append('effectiveDate', this.effectiveDate);
        formData.append('policyNumber', this.policyNumber);
        var data = sessionStorage.getItem('leadId')
        formData.append('leadId', data);
        formData.append('agencyId',this.agencyId)
        //  this.fileData=formData

        this.uploadImagesAgency(formData)
      }

    }
  }

  async uploadImagesAgency(formData: FormData) {
    this.loading = true;
    this.user.submitFormService(this.config.uploadEoDOcAgency, formData).subscribe((data: any) => {
      this.expiryDate = "";
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      this.finalDocs = data.data;
      this.loading = false;
      Swal.fire({
        text: data.message,  
        icon: 'success',      
        confirmButtonColor: '#CC4037',       
        confirmButtonText: 'Ok'
      }).then((result) => {
        if (result.isConfirmed) {
      this.ProceedPromt();
    }
  })
      this.showExpiry = data.data.expiryDate;
      this.showDocumentName = data.data.documentName;
      this.showPolicyNumber = data.data.policyNumber;
      this.getAgencyDocuments(this.agencyId,this.leadId);      
      // this.fileId = data.data.id;
      // this.import();
    }, err => {
      //  this.dismiss();
    });

  }

  uploadlicensefileAgency(uploadlic, i) {

    var flag = true
    var errormsg = [];
    uploadlic.expiryDateLic = this.DatePipe.transform(uploadlic.expiryDateLic1, 'yyyy-MM-dd');
    uploadlic.effectiveDateLic = this.DatePipe.transform(uploadlic.effectiveDateLic1, 'yyyy-MM-dd');
    //if(uploadlic.showemailErrorMsgone==true){}
    if (!uploadlic.filelicens || uploadlic.filelicens.length <= 0 || uploadlic.showemailErrorMsgone == true) { uploadlic.showemailErrorMsgone = true; flag = false; errormsg.push('Choose File') }
    if (!uploadlic.licenseNumber || uploadlic.licenseNumber.length <= 0) { uploadlic.showlicnErrorMsgone = true; flag = false; errormsg.push('Enter License Number') }
    // if(!uploadlic.licenseType || uploadlic.licenseType.length <= 0){uploadlic.showlictErrorMsgone = true;  flag=false; errormsg.push('License Type')} 
    if (!uploadlic.expiryDateLic || uploadlic.expiryDateLic.length <= 0) { uploadlic.showlicdErrorMsgone = true; flag = false; errormsg.push('Enter Expiry Date') }
    if (!uploadlic.province || uploadlic.province.length <= 0) { uploadlic.showlicpErrorMsgone = true; flag = false; errormsg.push('Select Province') }
    // if(!uploadlic.licenseName || uploadlic.licenseName.length <= 0){uploadlic.showlicnameErrorMsgone=true;  flag=false; errormsg.push('Provience')} 
    if (!uploadlic.effectiveDateLic || uploadlic.effectiveDateLic.length <= 0) { uploadlic.showlicEffectivedErrorMsgone = true; flag = false; errormsg.push('Enter Expiry Date') }

    if (flag == true) {
      this.FileUploadLicAgency(uploadlic, i);
    }
    else {
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replace(",", '<br />');
      Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')
    }
  }
  FileUploadLicAgency(uploadlic, k) {
    for (var i = 0; i < this.FileDataListLic.length; i++) {
      this.productPhotofile = this.FileDataListLic[i];
      if (this.productPhotofile != null) {
        const formData = new FormData();
        formData.append('file', this.productPhotofile);
        formData.append('expiryDate', uploadlic.expiryDateLic);
        formData.append('effectiveDate', uploadlic.effectiveDateLic);
        var data = sessionStorage.getItem('leadId');

        formData.append('leadId', data);
        formData.append('licencesNumber', uploadlic.licenseNumber);
        formData.append('lincencesName', uploadlic.licenseName);

        formData.append('licencesType', uploadlic.type);
        formData.append('province', uploadlic.province);
        formData.append('agencyId',this.agencyId)

        if(this.licensRequestId !=null ){
          formData.append('requestedId', this.licensRequestId);
        }
        // this.fileData=formData

        this.uploadImagesLicAgency(formData, k)
      }

    }
  }

  async uploadImagesLicAgency(formData: FormData, k) {
    this.loading = true;
    if(this.licensRequestId !=null ){
      this.user.submitFormService(this.config.uploadLicensesAgency, formData).subscribe((data: any) => {
        this.loading = false;
        Swal.fire({
          text: data.message,  
          icon: 'success',      
          confirmButtonColor: '#CC4037',       
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.isConfirmed) {
        this.ProceedPromt();
      }
    })
        this.getAgencyDocuments(this.agencyId,this.leadId);  
        this.getLicensRequest();    
        this.getEORequest();
        this.getVoidChequeRequest();
        //  this.showlicense=true;
        this.fileenoNameLic = "";
        this.licensRequestId=null;
        this.uploadlicenseArray.splice(k, 1);
        this.uploadlicenseArray.push(data.data)
        this.getLicencesData.splice(k, 1);
        this.getLicencesData.push(data.data)
      }, err => {
  
      });    }else{
      this.user.submitFormService(this.config.uploadLicensesAgency, formData).subscribe((data: any) => {
        this.loading = false;
        Swal.fire({
          text: data.message,  
          icon: 'success',      
          confirmButtonColor: '#CC4037',       
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.isConfirmed) {
        this.ProceedPromt();
      }
    })
        this.getAgencyDocuments(this.agencyId,this.leadId);      
        //  this.showlicense=true;
        this.fileenoNameLic = "";
        this.licensRequestId=null;
        this.uploadlicenseArray.splice(k, 1);
        this.uploadlicenseArray.push(data.data)
        this.getLicencesData.splice(k, 1);
        this.getLicencesData.push(data.data)
      }, err => {
  
      });
    }
    

  }

  uploadVoidAgency(item, i) {
    var flag = true
    var errormsg = [];
    if(this.btnPopupName == "Confirm") {
      if (!item.fileId || item.fileId.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
    }else {
      if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
    }
    // if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
    if ( this.voidSizeCheck==true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Please upload the filesize less than 4MB')}
    // if(!this.expiryDate || this.expiryDate.length <= 0){this.showdateErrorMsg = true;  flag=false; errormsg.push('Date')} 

    if (flag == true) {
      //
      this.FileUploadVoidAgency(item, i);

    }
    else {
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replace(",", '<br />');
      // Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')

    }
  }
  FileUploadVoidAgency(item, k) {
    //
    for (var i = 0; i < this.FileDataList1.length; i++) {
      this.productPhotofile1 = this.FileDataList1[i];
      if (this.productPhotofile1 != null) {
        const formData = new FormData();
        formData.append('file', this.productPhotofile1);
        var data = sessionStorage.getItem('leadId')
        formData.append('leadId', data);
        // formData.append('fileId', this.fileIdvoid);
        formData.append('agencyId',this.agencyId)
        //  this.fileData=formData

        this.uploadImagesvoidAgency(formData, k)
      }

    }
  }
  async uploadImagesvoidAgency(formData: FormData, k) {
    this.loading = true;
    this.user.submitFormService(this.config.uploadVoidAgency, formData).subscribe((data: any) => {

      this.finalDocs1 = data.data;
      this.loading = false;
      Swal.fire({
        text: data.message,  
        icon: 'success',      
        confirmButtonColor: '#CC4037',       
        confirmButtonText: 'Ok'
      }).then((result) => {
        if (result.isConfirmed) {
      this.ProceedPromt();
    }
  })
      // this.showcheque=true;
      this.showchequeAgency = true;
      this.getAgencyDocuments(this.agencyId,this.leadId);

      this.showDocumentName1 = data.data.documentName;
      this.fileenoName1 = ""
      this.uploadvoidchequeArray.splice(k, 1);
      this.uploadvoidchequeArray.push(data.data)
    }, err => {

    });

  }
  getMisc:[];
  pdfmodelMisc:boolean=false;
  UrlMisc:any
  miscPreview:any;
  selectedFileName:any
  getMiscDocument(){
    this.user.getMiscDocument(this.leadId).pipe()
  .subscribe(
      data => {
          this.getMisc = data.data;
      },error=>{
          },()=>{});
  }
  onPreviewMisc(url,fileIdMisc) {
    // this.licensPreview = url;
    this.user.getLeadPreviewLink(fileIdMisc).pipe()
    .subscribe(
        data => {
            
         this.UrlMisc=data.data
     
        },error=>{
       
            if(error.status == 400 || error.status==417){
                this.error=error.error.data;
               
             }
             else{
               
               this.error="Something went wrong.";
             }
        
            },()=>{});
            this.selectedFileName = name;
      //this.docId = id;
    setTimeout(() => 
    {
      this.pdfmodelMisc = !this.pdfmodelMisc;
    },
    2500);
    // this.licensPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url)

  }

  getDocumentDeleteCheck() {
    
    this.user.getdocuments().pipe()
      .subscribe(
        data => {
          this.docFileId=undefined;
          this.showExpiry=null;
          this.MgaLicType=[];
          this.corporateLicType=[];
          this.individualLicType=[];
          this.showLicTypeonPopup=[];
          this.uploadlicenseArray = [];
          this.getLicencesData=[];
          this.uploadvoidchequeArray = []; 
          // this.uploadDocStatus = false;
          this.showCompanyDelete=false;  
          this.provienceList = data.data.provinces;
          this.licencesType = data.data.licencesTypes
          for(let i=0; i<data.data.licencesTypes.length; i++){
            var testOVr = data.data.licencesTypes[i].toLowerCase();
            if (testOVr.slice(-2)=='dr' || testOVr.indexOf('corporate') > -1){
              if(data.data.licencesTypes[i]!=="General 3 - DR"){
              this.corporateLicType.push(data.data.licencesTypes[i])
              this.MgaLicType.push(data.data.licencesTypes[i])
              }
            } 
            if(testOVr.indexOf('corporate') > -1){
              
            }
            else{
              this.individualLicType.push(data.data.licencesTypes[i])
            }
          }
          this.showLicTypeonPopup=this.individualLicType;
          if (data.data.documents != null) {
            if (data.data.documents?.length != 0) {
              this.uploaddocs();
              this.showExpiry = data.data.documents?.expiryDate;
              this.showDocumentName = data.data.documents?.documentName;
              this.showPolicyNumber = data.data.documents?.policyNumber;
              this.finalDocs = data.data.documents;
              this.fileUrlForEno = data.data.documents?.fileUrl;
              this.docId = data.data.documents?.id
              this.docFileId = data.data.documents?.fileId
              this.doctrimtoUrl = data.data.documents?.documentName;
              try{this.doctrimUrl = this.doctrimtoUrl.split('.').pop();}catch{}
              this.checkedDoc = data.data.documents?.status;
              if(this.checkedDoc=="Approved"){
                this.showRemove=true;
              }
              this.checkDocdesc=data.data.documents?.description

            }
          }
          if (data.data.licences.length != 0) {
            for (var i = 0; i < data.data.licences.length; i++) {
              var obj = {}
              //this.uploadlicenseArray.push(data.data.licences[i]);
              try{obj["urltreamlic"] = data.data.licences[i].licenseName.split('.').pop();}catch{}
              obj["createdAt"] = data.data.licences[i].createdAt;
              obj["createdBy"] = data.data.licences[i].createdBy;
              obj["description"] = data.data.licences[i].description;
              obj["expiryDate"] = data.data.licences[i].expiryDate;
              obj["fileDownloadUrl"] = data.data.licences[i].fileDownloadUrl;
              obj["fileId"] = data.data.licences[i].fileId;
              obj["fileUrl"] = data.data.licences[i].fileUrl;
              obj["id"] = data.data.licences[i].id;
              obj["lastModifiedBy"] = data.data.licences[i].lastModifiedBy;
              obj["licencesProvince"] = data.data.licences[i].licencesProvince;
              obj["licencesType"] = data.data.licences[i].licencesType;
              obj["licenseName"] = data.data.licences[i].licenseName;
              obj["licensesNumber"] = data.data.licences[i].licensesNumber;
              obj["status"] = data.data.licences[i].status;
              obj["type"] = data.data.licences[i].type;
              obj["updatedAt"] = data.data.licences[i].updatedAt;
              obj["provinceName"] = data.data.licences[i].provinces.provinceName;
              obj["provinceCode"] = data.data.licences[i].provinces.provinceCode;
              obj["isFirstTimeUpload"] = data.data.licences[i].isFirstTimeUpload;
              obj["isEditableDocument"] = data.data.licences[i].isEditableDocument;
              this.uploadlicenseArray.push(obj)
              this.getLicencesData.push(obj)
            }
            this.uploadlicstatus()
          }
          else{
            this.addFieldValue();
          }
          if (data.data.accountDetails.length != 0) {
          
            for (var i = 0; i < data.data.accountDetails.length; i++) {
              var obj = {}
              // this.uploadvoidchequeArray.push(data.data.accountDetails[i])
              try{obj["urltreamvoid"] = data.data.accountDetails[i].fileDownloadUrl.split('.').pop();}catch{}
              obj["createdAt"] = data.data.accountDetails[i].createdAt;
              obj["createdBy"] = data.data.accountDetails[i].createdBy;
              obj["description"] = data.data.accountDetails[i].description;
              obj["documentName"] = data.data.accountDetails[i].documentName;
              obj["fileDownloadUrl"] = data.data.accountDetails[i].fileDownloadUrl;
              obj["fileId"] = data.data.accountDetails[i].fileId;
              obj["fileUrl"] = data.data.accountDetails[i].fileUrl;
              obj["id"] = data.data.accountDetails[i].id;
              obj["lastModifiedBy"] = data.data.accountDetails[i].lastModifiedBy;
              obj["status"] = data.data.accountDetails[i].status;
              obj["type"] = data.data.accountDetails[i].type;
              obj["updatedAt"] = data.data.accountDetails[i].updatedAt;
              obj["isFirstTimeUpload"] = data.data.accountDetails[i].isFirstTimeUpload;
              obj["isEditableDocument"] = data.data.accountDetails[i].isEditableDocument;
              this.uploadvoidchequeArray.push(obj)
            }
            this.uploadvoidstatus();
          }
          else{
            this.addFieldValuecheque();
          }
          if(data.data.accountDetails?.length != 0 && data.data.documents?.length != 0 &&
            data.data.licences.length != 0){
              this.uploadDocStatus = true;
            }
            else{
              this.uploadDocStatus = false;
            }
        
        }, error => {
          //  if(this.baseservice.handleError(error)){
          //handle Exception from Server 404,401
          if (error.status == 400 || error.status == 417) {
            this.error = error.error.data;

          }
          else {

            this.error = "Something went wrong.Please try again later.";
          }

        }, () => { });

  }

  getAgencyDocumentsForDelete(agencyId,leadId){
    //this.agencyDocApiError=true;
    if(this.agencyId!=undefined){
    this.user.getAgencydocuments(agencyId,leadId).pipe()
    .subscribe(
      data => {
      
        this.uploadlicenseArray = [];
        this.getLicencesData=[]
        this.uploadvoidchequeArray = [];
        this.expiryDate1=null;
        this.effectiveDate1=null;
        this.agencyDocApiError=false;
        this.showCompanyDelete=true;
        // this.provienceList = data.data.provinces;
        // this.licencesType = data.data.licencesTypes
        if (data.data.documents != null) {
          if (data.data.documents?.length != 0) {
            this.uploaddocsAgency();
            this.showExpiry = data.data.documents?.expiryDate;
            this.showDocumentName = data.data.documents?.documentName;
            this.showPolicyNumber = data.data.documents?.policyNumber;
            this.finalDocs = data.data.documents;
            this.fileUrlForEno = data.data.documents?.fileUrl;
            this.docId = data.data.documents?.id
            this.docFileId = data.data.documents?.fileId
            this.doctrimtoUrl = data.data.documents?.documentName;
            try{this.doctrimUrl = this.doctrimtoUrl.split('.').pop();}catch{}
            this.checkedDoc = data.data.documents?.status;
            if(this.checkedDoc=="Approved"){
              this.showRemove1=true;
            }
           
            this.checkDocdesc=data.data.documents?.description
            // if(this.checkedDoc != 'Not Approved' || this.checkedDoc != 'More Information Required'){
            //   // this.uploadvoidstatusAgency();
            //   this.showdocumentsAgency = false;
            // }
          }
        }
        if (data.data.licences.length != 0) {
      
          for (var i = 0; i < data.data.licences.length; i++) {
            var obj = {}
            //this.uploadlicenseArray.push(data.data.licences[i]);
            try{obj["urltreamlic"] = data.data.licences[i].licenseName.split('.').pop();}catch{}
            obj["createdAt"] = data.data.licences[i].createdAt;
            obj["createdBy"] = data.data.licences[i].createdBy;
            obj["description"] = data.data.licences[i].description;
            obj["expiryDate"] = data.data.licences[i].expiryDate;
            obj["fileDownloadUrl"] = data.data.licences[i].fileDownloadUrl;
            obj["fileId"] = data.data.licences[i].fileId;
            obj["fileUrl"] = data.data.licences[i].fileUrl;
            obj["id"] = data.data.licences[i].id;
            obj["lastModifiedBy"] = data.data.licences[i].lastModifiedBy;
            obj["licencesProvince"] = data.data.licences[i].licencesProvince;
            obj["licencesType"] = data.data.licences[i].licencesType;
            obj["licenseName"] = data.data.licences[i].licenseName;
            obj["licensesNumber"] = data.data.licences[i].licensesNumber;
            obj["status"] = data.data.licences[i].status;
            obj["type"] = data.data.licences[i].type;
            obj["updatedAt"] = data.data.licences[i].updatedAt;
            obj["provinceName"] = data.data.licences[i].provinces.provinceName;
            obj["provinceCode"] = data.data.licences[i].provinces.provinceCode;
            obj["isFirstTimeUpload"] = data.data.licences[i].isFirstTimeUpload;
            obj["isEditableDocument"] = data.data.licences[i].isEditableDocument;
            this.uploadlicenseArray.push(obj)
            this.getLicencesData.push(obj)
          }
          this.uploadlicstatusAgency()
          //   
          // if(data.data.licences[i].status != 'Not Approved' || data.data.licences[i].status != 'More Information Required'){
          //   // this.uploadvoidstatusAgency();
          //   this.showlicenseAgency = false;
          // }
        }
        else{
          this.addFieldValue();
        }
        if (data.data.accountDetails.length != 0) {
    
          for (var i = 0; i < data.data.accountDetails.length; i++) {
            var obj = {}
            // this.uploadvoidchequeArray.push(data.data.accountDetails[i])
            try{obj["urltreamvoid"] = data.data.accountDetails[i].fileDownloadUrl.split('.').pop();}catch{}
            obj["createdAt"] = data.data.accountDetails[i].createdAt;
            obj["createdBy"] = data.data.accountDetails[i].createdBy;
            obj["description"] = data.data.accountDetails[i].description;
            obj["documentName"] = data.data.accountDetails[i].documentName;
            obj["fileDownloadUrl"] = data.data.accountDetails[i].fileDownloadUrl;
            obj["fileId"] = data.data.accountDetails[i].fileId;
            obj["fileUrl"] = data.data.accountDetails[i].fileUrl;
            obj["id"] = data.data.accountDetails[i].id;
            obj["lastModifiedBy"] = data.data.accountDetails[i].lastModifiedBy;
            obj["status"] = data.data.accountDetails[i].status;
            obj["type"] = data.data.accountDetails[i].type;
            obj["updatedAt"] = data.data.accountDetails[i].updatedAt;
            obj["isFirstTimeUpload"] = data.data.accountDetails[i].isFirstTimeUpload;
            obj["isEditableDocument"] = data.data.accountDetails[i].isEditableDocument;
            this.uploadvoidchequeArray.push(obj)
          }
          
           this.uploadvoidstatusAgency();
          //    
          //  if(data.data.accountDetails[i].status != 'Not Approved' || data.data.accountDetails[i].status != 'More Information Required'){
          //   // this.uploadvoidstatusAgency();
          //   this.showchequeAgency = false;
          // }
        }
        else{
          this.addFieldValuecheque();
        }
        if(data.data.accountDetails?.length != 0 && data.data.documents?.length != 0 &&
          data.data.licences.length != 0){
            this.uploadDocStatus = true;
          }
          else{
            this.uploadDocStatus = false;
          }
 
      }, error => {
        //  if(this.baseservice.handleError(error)){
        //handle Exception from Server 404,401
      
      }, () => { });
    }
      else{
        this.uploadvoidchequeArray = [];
        this.uploadlicenseArray = [];
        this.getLicencesData=[];
        this.addFieldValue();
        //this.addFieldValuecheque();
          }
  }
  clearLicType(i){

  }
 requestLicensarray=[]
getLicensRequest(){
    this.user.getLicenseRequestCall(this.leadId,'LINCENCES').pipe()
  .subscribe(
      data => {
        if(data.status==true){
        this.requestLicensarray=[]
        this.requestLicensarray=data.data
        this.showforProceed=false
        }else{
        this.requestLicensarray=[]
        }
      },error=>{
          },()=>{});
  }
  licensRequestId: any;
  checkLicRequested:boolean=false;
  duplicatedlicensRequestId:boolean=false;
  clickOnRequest(id){
    
   this.licensRequestId=id;
   this.duplicatedlicensRequestId=id;
   this.uploadLicensePopup = true;
   this.checkLicRequested=true;
   try{
   this.getLicencesData[this.getLicencesData.length-1].province=null;
   this.getLicencesData[this.getLicencesData.length-1].type=null;
  }catch{}
   console.log(this.getLicencesData)
  }
  DocmoreInfoReq(leadId){
    
    this.user.DocmoreInfoReq(leadId).pipe()
  .subscribe(
      data => {
        
          console.log(data.data);
          sessionStorage.setItem('DocmoreInfoReq', data.data)
      },error=>{
          },()=>{});
  }
  editBankInfo(){
    //
    // this.uploadVoidChequePopup = true;
    this.bankInfoErrmsg = false;
    this.popupName="Update";
    this.btnPopupName ="Save";
    this.btncancelPopupName ="Cancel";
  }
  editBankInfoPop(){
    //
    this.bankinfoChecked = false;
    this.transitNm = this.transitNo;
    this.financialInstNumber = this.financialInstitutionNo;
    this.accNm = this.accountNo;
    this.confirmaccountNo = this.accountNo;
    this.bankInfoErrmsg=false
  }
  closeBankInfoPopup(){
    //
    this.BankInfo = false;
    this.bankName = this.bankNm;
    this.transitNo = this.transitNm;
    this.financialInstitutionNo = this.financialInstNumber;
    this.accountNo = this.accNm;
    this.confirmaccountNo = this.accNm;
    this.bankInfoErrmsg=false
  }
  // BankNameErrMsgred(){
  //   try{this.BankName=this.BankName.trim()}catch{}
  //   if(!this.BankName){this.BankNameErrMsg = true} else{this.BankNameErrMsg = false}}
  // holderNameErrMsgred(){
  //   try{this.holderName=this.holderName.trim()}catch{}
  //   if(!this.holderName){this.holderNameErrMsg = true} else{this.holderNameErrMsg = false}}
  // branchAddressErrMsgred(){
  //   try{this.branchAddress=this.branchAddress.trim()}catch{}
  //   if(!this.branchAddress){this.branchAddressErrMsg = true} else{this.branchAddressErrMsg = false}}
  confirmaccountNoErrMsgred(){
    try{this.confirmaccountNo=this.confirmaccountNo.trim()}catch{}
    if(!this.confirmaccountNo){this.confirmaccountNoErrMsg = true} else{this.confirmaccountNoErrMsg = false}}
  transitNoErrMsgred(){
    try{this.transitNo=this.transitNo.trim()}catch{}
    if(!this.transitNo){this.transitNoErrMsg = true} else{this.transitNoErrMsg = false}}
  financialInstitutionNoErrMsgred(){
    try{this.financialInstitutionNo=this.financialInstitutionNo.trim()}catch{}
    if(!this.financialInstitutionNo){this.financialInstitutionNoErrMsg = true} else{this.financialInstitutionNoErrMsg = false}}
  accountNoErrMsgred(){
    try{this.accountNo=this.accountNo.trim()}catch{}
    if(!this.accountNo){this.accountNoErrMsg = true} else{this.accountNoErrMsg = false}
  }
  confirmAccountNumberMatch: boolean=false;
  accountConfirmFlag:boolean=false;
  checkConfirmAccountNumber(){
    try{this.confirmaccountNo=this.confirmaccountNo.trim()}catch{}
    if(!this.confirmaccountNo){this.confirmaccountNoErrMsg = true} else{this.confirmaccountNoErrMsg = false}
    
    if(this.accountNo && this.confirmaccountNo){
      if(this.accountNo==this.confirmaccountNo){
        this.confirmAccountNumberMatch = false;
        this.accountConfirmFlag = false;
      }else{
        this.confirmAccountNumberMatch = true;
        this.accountConfirmFlag = false;
      }
    }
    
  }
  checkAccountNumber(){
    try{this.accountNo=this.accountNo.trim()}catch{}
    if(!this.accountNo){this.accountNoErrMsg = true} else{this.accountNoErrMsg = false}
    
    if(this.accountNo && this.confirmaccountNo){
      if(this.accountNo==this.confirmaccountNo){
        this.confirmAccountNumberMatch = false;
        this.accountConfirmFlag = false;
        // this.allowUser=true
      }else{
        this.confirmAccountNumberMatch = true;
        this.accountConfirmFlag = false;
        // this.allowUser=false
      }
    }
    
  }
  allowUser: boolean=false;
  onBankInfoSelected(data){
    //
    var checkFlag = data.target.checked;
    if(checkFlag == true){
      this.allowUser = true;
      this.bankInfoErrmsg = false;
      this.bankinfoChecked=true;
    }
    else{
      this.bankInfoErrmsg = true;
      this.allowUser = false;
      this.bankinfoChecked=false;
    }
  }
  cancelBtnPopup(){
    this.uploadVoidChequePopup = false;
    this.bankInfoErrmsg = false;
    this.bankName = this.bankNm;
    this.transitNo = this.transitNm;
    this.financialInstitutionNo = this.financialInstNumber;
    this.accountNo = this.accNm;
    this.confirmaccountNo = this.accNm;
    this.allowUser=false
  }
  uploadBankingInfo(){
    this.BankInfo = true;
    this.transitNo = this.transitNm;
    this.financialInstitutionNo = this.financialInstNumber;
    this.accountNo = this.accNm;
    this.confirmaccountNo = this.accNm;
  }
  callMgaDoc(){
    this.getLicensRequest()
      this.getEORequest();
      this.getVoidChequeRequest();
    this.getMGADocuments();
    this.openTabs2(2)
    this.fileenoNameLic=null;
    this.fileenoName=null;
    this.fileenoName1=null;
    this.uploadlicenseArray = [];
    this.getLicencesData=[];
    this.uploadvoidchequeArray = [];
    this.fileeno=""
    this.policyNumber=""
    this.expiryDate1=""
    this.effectiveDate1=""
    this.callMgaAPI=true
    this.bankinfoChecked=false
  }
  getMGADocuments(){
    
    this.user.getMGAdocument(this.mgaId,this.leadId).pipe()
    .subscribe(
      data => {
      
        this.expiryDate1=null;
        this.effectiveDate1=null;
        this.uploadlicenseArray = [];
        this.getLicencesData=[]
        this.uploadvoidchequeArray = [];
        // this.provienceList = data.data.provinces;
        // this.licencesType = data.data.licencesTypes
        if (data.data.documents != null) {
          this.showdocumentsMgaNA=true
          if (data.data.documents?.length != 0) {
            this.uploaddocsMGA();
            this.showExpiry = data.data.documents?.expiryDate;
            this.showDocumentName = data.data.documents?.documentName;
            this.showPolicyNumber = data.data.documents?.policyNumber;
            this.finalDocs = data.data.documents;
            this.fileUrlForEno = data.data.documents?.fileUrl;
            this.docId = data.data.documents?.id
            this.docFileId = data.data.documents?.fileId
            this.doctrimtoUrl = data.data.documents?.documentName;
            try{this.doctrimUrl = this.doctrimtoUrl.split('.').pop();}catch{}
            this.checkedDoc = data.data.documents?.status;
            this.isFirstTimeUploadedEOMGA=data.data.documents?.isFirstTimeUpload;
            this.isEditableDocumentEOMGA=data.data.documents?.isEditableDocument
            if(this.checkedDoc=="Approved"){
              this.showRemove1=true;
            }
            if(this.checkedDoc=="Not Approved"|| this.checkedDoc=="More Information Required"){
              this.showdocumentsMgaNA=false 
              
            }
            this.checkDocdesc=data.data.documents?.description
            
          }
        }

        if (data.data.licences.length != 0) {
          this.showlicenseMgaNA=true
          this.uploadlicstatusMGA()
          for (var i = 0; i < data.data.licences.length; i++) {
            var obj = {}
            //this.uploadlicenseArray.push(data.data.licences[i]);
            try{obj["urltreamlic"] = data.data.licences[i].licenseName.split('.').pop();}catch{}
            obj["createdAt"] = data.data.licences[i].createdAt;
            obj["createdBy"] = data.data.licences[i].createdBy;
            obj["description"] = data.data.licences[i].description;
            obj["expiryDate"] = data.data.licences[i].expiryDate;
            obj["fileDownloadUrl"] = data.data.licences[i].fileDownloadUrl;
            obj["fileId"] = data.data.licences[i].fileId;
            obj["fileUrl"] = data.data.licences[i].fileUrl;
            obj["id"] = data.data.licences[i].id;
            obj["lastModifiedBy"] = data.data.licences[i].lastModifiedBy;
            obj["licencesProvince"] = data.data.licences[i].licencesProvince;
            obj["licencesType"] = data.data.licences[i].licencesType;
            obj["licenseName"] = data.data.licences[i].licenseName;
            obj["licensesNumber"] = data.data.licences[i].licensesNumber;
            obj["status"] = data.data.licences[i].status;
            obj["type"] = data.data.licences[i].type;
            obj["updatedAt"] = data.data.licences[i].updatedAt;
            obj["provinceName"] = data.data.licences[i].provinces.provinceName;
            obj["provinceCode"] = data.data.licences[i].provinces.provinceCode;
            obj["isFirstTimeUpload"] = data.data.licences[i].isFirstTimeUpload;
            obj["isEditableDocument"] = data.data.licences[i].isEditableDocument;
            if(data.data.licences[i].status=="Not Approved"|| data.data.licences[i].status=="More Information Required"){
              this.showlicenseMgaNA=false 
              
            }
            this.uploadlicenseArray.push(obj)
            this.getLicencesData.push(obj)
          }
          
         
        }
        else if(this.uploadlicenseArray.length<1){
          this.addFieldValue();
        }
        
        if(data.data.accountDetails.length!=0){
          this.transitNo = data.data.accountDetails[0]?.transitNumber;
          this.financialInstitutionNo = data.data.accountDetails[0]?.finacialInstitutionNumber;
          this.accountNo = data.data.accountDetails[0]?.accountNumber;
          this.confirmaccountNo = data.data.accountDetails[0]?.accountNumber;
          this.maskaccountNo = data.data.accountDetails[0]?.accountNumber;
          this.eyeIconShowAccountNumber = data.data.accountDetails[0]?.accountNumberPlain;
        }
        else{
          this.transitNo =null;
          this.financialInstitutionNo=null;
          this.accountNo=null;
          this.confirmaccountNo =null;
          this.maskaccountNo =null;
          this.eyeIconShowAccountNumber =null;
        }
        if (data.data.accountDetails.length != 0) {
          this.uploadvoidchequeArray = [];
          this.showchequeMgaNA=true
          this.uploadvoidstatusMGA();
          for (var i = 0; i < data.data.accountDetails.length; i++) {
            var obj = {}
            // this.uploadvoidchequeArray.push(data.data.accountDetails[i])
            try{obj["urltreamvoid"] = data.data.accountDetails[i].documentName.split('.').pop();}catch{}
            obj["createdAt"] = data.data.accountDetails[i].createdAt;
            obj["createdBy"] = data.data.accountDetails[i].createdBy;
            obj["description"] = data.data.accountDetails[i].description;
            obj["documentName"] = data.data.accountDetails[i].documentName;
            obj["fileDownloadUrl"] = data.data.accountDetails[i].fileDownloadUrl;
            obj["fileId"] = data.data.accountDetails[i].fileId;
            obj["fileUrl"] = data.data.accountDetails[i].fileUrl;
            obj["id"] = data.data.accountDetails[i].id;
            obj["lastModifiedBy"] = data.data.accountDetails[i].lastModifiedBy;
            obj["status"] = data.data.accountDetails[i].status;
            obj["type"] = data.data.accountDetails[i].type;
            obj["updatedAt"] = data.data.accountDetails[i].updatedAt;
            obj["isFirstTimeUpload"] = data.data.accountDetails[i].isFirstTimeUpload;
            obj["isEditableDocument"] = data.data.accountDetails[i].isEditableDocument;
            this.uploadvoidchequeArray.push(obj)
            if(data.data.accountDetails[i].status=="Not Approved"|| data.data.accountDetails[i].status=="More Information Required"){
              this.showchequeMgaNA=false 
            }
                 
        
          }
         
        }
        else if(this.uploadvoidchequeArray.length<1){
          this.addFieldValuecheque();
        }
        if(data.data.accountDetails?.length != 0 && data.data.documents?.length != 0 &&
          data.data.licences.length != 0){
            this.uploadDocStatus = true;
          }
          else{
            this.uploadDocStatus = false;
          }
 
      }, error => {
        //  if(this.baseservice.handleError(error)){
        //handle Exception from Server 404,401
      
      }, () => { });
   
 
  }
  uploaddocsMGA() {
    this.showdocumentsMGA = true;
  }
  uploadlicstatusMGA() {
    this.showlicenseMGA = true;
 }
uploadvoidstatusMGA() {
   
   this.showchequeMGA = true;
 }
 uploadEnoMGA() {
  var flag = true
  var errormsg = [];
  this.expiryDate = this.DatePipe.transform(this.expiryDate1, 'yyyy-MM-dd');
  this.effectiveDate = this.DatePipe.transform(this.effectiveDate1, 'yyyy-MM-dd');
  if (!this.fileeno || this.fileeno.length <= 0 || this.showemailErrorMsg == true) { this.showemailErrorMsg = true; flag = false; errormsg.push('Choose File') }
  if (!this.expiryDate || this.expiryDate.length <= 0) { this.showdateErrorMsg = true; flag = false; errormsg.push('Enter Expiry Date') }
  if (!this.policyNumber || this.policyNumber.length <= 0) { this.showdateErrorMsg = true; flag = false; errormsg.push('Enter E&O Policy Number') }
  if (this.enoSizeCheck==true) { this.showemailErrorMsg = true; flag = false; errormsg.push('Please upload the filesize less than 4MB') }
  if (!this.effectiveDate || this.effectiveDate.length <= 0) { this.showEffectivedateErrorMsg = true; flag = false; errormsg.push('Enter Effective Date') }

  
  if (flag == true) {
    this.documentType="EO"
    this.FileUploadMGA();
  }
  else {
    this.msg = errormsg.toString();
    this.msgfinal = this.msg.replace(",", '<br />');
    Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')

  }
}
 FileUploadMGA() {
  if(this.FileDataList!=undefined){
  for (var i = 0; i < this.FileDataList.length; i++) {
    this.productPhotofile = this.FileDataList[i];
    if (this.productPhotofile != null) {
      const formData = new FormData();
      formData.append('file', this.productPhotofile);
      formData.append('expiryDate', this.expiryDate);
      formData.append('effectiveDate', this.effectiveDate);
      formData.append('leadId', this.leadId);
      // formData.append('agencyId',this.agencyId)
      formData.append('DocNumber',this.policyNumber)
      // formData.append('accountNumber',this.agencyId)
      // formData.append('bankNumber',this.policyNumber)
      formData.append('docName',this.fileenoName)
      formData.append('documentFor',"MGA")
      
      formData.append('documentType',this.documentType)
      formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO))
      formData.append('mgaId',this.mgaId)
      if(this.docId!=undefined || this.docId!=null){
        if(this.isOverWriteEO==true){
        formData.append('documentId',this.docId)
        }
      }
      // formData.append('province',this.agencyId)
      // formData.append('transitNumber',this.agencyId)
      //  this.fileData=formData

      this.uploadImagesMGA(formData)
    }

  }
}else{
  this.overwriteEoMGATest()
      }
}
async uploadImagesMGA(formData: FormData) {
  this.loading = true;
  if(this.documentId==null){
  this.user.submitFormService(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
    this.expiryDate = null;
    this.fileeno = "";
    this.fileenoName = "";
    this.policyNumber = "";
    this.finalDocs = data.data;
    this.loading = false;
    this.uploadEOPopup = false;
    this.isOverWriteEO=false
    Swal.fire({
      text: data.message,  
      icon: 'success',      
      confirmButtonColor: '#CC4037',       
      confirmButtonText: 'Ok'
    }).then((result) => {
      if (result.isConfirmed) {
    this.ProceedPromt();
  }
})
    this.showExpiry = data.data.expiryDate;
    this.showDocumentName = data.data.documentName;
    this.showPolicyNumber = data.data.policyNumber;
    // this.callAgencyApi=false;
    // this.callMgaAPI=true;
    this.openTabs2(2);
    this.getMGADocuments()

  }, err => {
  });
}else{
  this.user.OverWriteEO(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
   
    this.expiryDate = null;
    this.fileeno = "";
    this.fileenoName = "";
    this.policyNumber = "";
    this.finalDocs = data.data;
    this.loading = false;
    this.documentId=null;

    this.fileId=null;
    this.uploadEOPopup = false;
    Swal.fire({
      text: data.message,  
      icon: 'success',      
      confirmButtonColor: '#CC4037',       
      confirmButtonText: 'Ok'
    }).then((result) => {
      if (result.isConfirmed) {
    this.ProceedPromt();
  }
})
    this.showExpiry = data.data.expiryDate;
    this.showDocumentName = data.data.documentName;
    this.showPolicyNumber = data.data.policyNumber;
    // this.callAgencyApi=false;
    // this.callMgaAPI=true;
    this.openTabs2(2);
    this.getMGADocuments()
  }, err => {
  });
}
}
overwriteEoMGATest(){

  const formData = new FormData();
    formData.append('expiryDate', this.expiryDate);
    formData.append('effectiveDate', this.effectiveDate);
      formData.append('policyNumber', this.policyNumber);
      var data = this.leadId
      formData.append('leadId', data);
      // formData.append('agencyId',this.agencyId)
      formData.append('documentId', this.docId)
      formData.append('fileId', this.fileId)
      formData.append('documentFor',"MGA")
      
      formData.append('documentType',this.documentType)
      formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO))
     
      formData.append('mgaId',this.mgaId)
  this.user.OverWriteEO(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
     
    this.expiryDate = null;
    this.fileeno = "";
    this.fileenoName = "";
    this.policyNumber = "";
    this.finalDocs = data.data;
    this.loading = false;
    this.documentId=null;

    this.fileId=null;
    this.uploadEOPopup = !this.uploadEOPopup;
    Swal.fire({
      text: data.message,  
      icon: 'success',      
      confirmButtonColor: '#CC4037',       
      confirmButtonText: 'Ok'
    }).then((result) => {
      if (result.isConfirmed) {
    this.ProceedPromt();
  }
})
    this.showExpiry = data.data.expiryDate;
    this.showDocumentName = data.data.documentName;
    this.showPolicyNumber = data.data.policyNumber;
    // this.callAgencyApi=false;
    // this.callMgaAPI=true;
    this.openTabs2(2);
    this.getMGADocuments()
  }, err => {
  });
}
updateMgaShortName(){
  const request={
    "id": this.mgaId,
    "mgaShortName": this.mgaName,
  }
  this.user.submitFormService(this.config.updateMGAShortName, request).subscribe((data: any) => {
    this.editMGAShortName=false
    this.mgaName = data.data?.mgaShortName;
  }, err => {
  });
}
changeMGAShortName(){
  this.editMGAShortName =! this.editMGAShortName;
}
uploadlicensefileMGA(uploadlic, i) {

  var flag = true
  var errormsg = [];
  uploadlic.expiryDateLic = this.DatePipe.transform(uploadlic.expiryDateLic1, 'yyyy-MM-dd');
  uploadlic.effectiveDateLic = this.DatePipe.transform(uploadlic.effectiveDateLic1, 'yyyy-MM-dd');
  //if(uploadlic.showemailErrorMsgone==true){}
  if (!uploadlic.filelicens || uploadlic.filelicens.length <= 0 || uploadlic.showemailErrorMsgone == true) { uploadlic.showemailErrorMsgone = true; flag = false; errormsg.push('Choose File') }
  if (!uploadlic.licenseNumber || uploadlic.licenseNumber.length <= 0) { uploadlic.showlicnErrorMsgone = true; flag = false; errormsg.push('Enter License Number') }
  // if(!uploadlic.licenseType || uploadlic.licenseType.length <= 0){uploadlic.showlictErrorMsgone = true;  flag=false; errormsg.push('License Type')} 
  if (!uploadlic.expiryDateLic || uploadlic.expiryDateLic.length <= 0) { uploadlic.showlicdErrorMsgone = true; flag = false; errormsg.push('Enter Expiry Date') }
  if (!uploadlic.province || uploadlic.province.length <= 0) { uploadlic.showlicpErrorMsgone = true; flag = false; errormsg.push('Select Province') }
  // if(!uploadlic.licenseName || uploadlic.licenseName.length <= 0){uploadlic.showlicnameErrorMsgone=true;  flag=false; errormsg.push('Provience')} 
  if (!uploadlic.effectiveDateLic || uploadlic.effectiveDateLic.length <= 0) { uploadlic.showlicEffectivedErrorMsgone = true; flag = false; errormsg.push('Enter Effective Date') }

  if (flag == true) {
    this.documentType="LICENSES"
    this.FileUploadLicMGA(uploadlic, i);
  }
  else {
    this.msg = errormsg.toString();
    this.msgfinal = this.msg.replace(",", '<br />');
    Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')
  }
}
FileUploadLicMGA(uploadlic, k) {

  if(this.FileDataListLic!=undefined){
  for (var i = 0; i < this.FileDataListLic.length; i++) {
    this.productPhotofile = this.FileDataListLic[i];
    if (this.productPhotofile != null) {
      const formData = new FormData();
      formData.append('file', this.productPhotofile);
      formData.append('expiryDate', uploadlic.expiryDateLic);
      formData.append('effectiveDate', uploadlic.effectiveDateLic);

      formData.append('leadId', this.leadId);
      formData.append('DocNumber', uploadlic.licenseNumber);
      formData.append('docName', uploadlic.lincencesName);
      formData.append('licencesType', uploadlic.type);
      formData.append('province', uploadlic.province);
      // formData.append('agencyId',this.agencyId)
      formData.append('documentFor',"MGA")
      
      formData.append('documentType',this.documentType)
      formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO))
     
      formData.append('mgaId',this.mgaId)
if(this.fileIdlic!=null || this.licenceId!=null){
formData.append('fileId', this.fileIdlic);
// formData.append('licenceId', this.licenceId);
}
if(this.licensRequestId !=null ){
  formData.append('requestedId', this.licensRequestId);
}
if(this.licenceId!=null){
  if(this.isOverWriteEO==true){
    formData.append('documentId',this.licenceId)
    }
}
      // this.fileData=formData

      this.uploadImagesLicMGA(formData, k)
    }

  }
}
else{
  

      const formData = new FormData();
      
      formData.append('expiryDate', uploadlic.expiryDateLic);
      formData.append('effectiveDate', uploadlic.effectiveDateLic);
      formData.append('leadId', this.leadId);
      formData.append('DocNumber', uploadlic.licenseNumber);
      formData.append('docName', uploadlic.lincencesName);
      formData.append('licencesType', uploadlic.type);
      formData.append('province', uploadlic.province);
      // formData.append('agencyId',this.agencyId)
      formData.append('documentFor',"MGA")
      
      formData.append('documentType',this.documentType)
      formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO))
     
      formData.append('mgaId',this.mgaId)
if(this.fileIdlic!=null || this.licenceId!=null){
  if(this.isOverWriteEO==true){
    formData.append('documentId',this.licenceId)
    }
    if(this.licensRequestId !=null ){
      formData.append('requestedId', this.licensRequestId);
    }
}
      this.uploadImagesLicMGA(formData, k)
}
}
async uploadImagesLicMGA(formData: FormData, k) {
  
  this.loading = true;
  if(this.licenceId==null){
  this.user.submitFormService(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
    this.loading = false;
    Swal.fire({
      text: data.message,  
      icon: 'success',      
      confirmButtonColor: '#CC4037',       
      confirmButtonText: 'Ok'
    }).then((result) => {
      if (result.isConfirmed) {
    this.ProceedPromt();
  }
})
    this.uploadLicensePopup = false;
    // this.callAgencyApi=false;
    // this.callMgaAPI=true;
    this.openTabs2(2);
    this.getMGADocuments()
    this.getLicensRequest()
    this.getEORequest();
    this.getVoidChequeRequest();
    //  this.showlicense=true;
    this.fileenoNameLic = "";
    this.uploadlicenseArray.splice(k, 1);
    this.uploadlicenseArray.push(data.data)
  }, err => {

  });
}else{
  this.user.submitFormService1(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
    this.loading = false;
    this.licenceId=null;
     this.fileIdlic=null;
     Swal.fire({
      text: data.message,  
      icon: 'success',      
      confirmButtonColor: '#CC4037',       
      confirmButtonText: 'Ok'
    }).then((result) => {
      if (result.isConfirmed) {
    this.ProceedPromt();
  }
})
    // this.getDocument();
    this.uploadLicensePopup = false;
    // this.callAgencyApi=false;
    // this.callMgaAPI=true;
    this.openTabs2(2);
    this.getMGADocuments()
    this.getLicensRequest()
    this.getEORequest();
    this.getVoidChequeRequest();
    // this.showlicense=true;
    this.fileenoNameLic = "";
    this.uploadlicenseArray.splice(k, 1);
    this.uploadlicenseArray.push(data.data)
  }, err => {

  });
}
}
FileUploadVoidMGA(item, k) {

  if(this.FileDataList1!=undefined){
  for (var i = 0; i < this.FileDataList1.length; i++) {
    this.productPhotofile1 = this.FileDataList1[i];
    if (this.productPhotofile1 != null) {
      const formData = new FormData();
      formData.append('file', this.productPhotofile1);
      formData.append('leadId', this.leadId);
      // formData.append('agencyId',this.agencyId)
      //  this.fileData=formData
      formData.append('accountNumber', this.accountNo);
      formData.append('confirmaccountNo', this.confirmaccountNo);
      formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
      formData.append('transitNumber', this.transitNo);
      formData.append('bankNumber',this.financialInstitutionNo)
      formData.append('documentFor',"MGA");
          formData.append('documentType',this.documentType)
          formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO));
          formData.append('mgaId',this.mgaId)
      if(this.fileIdvoid!=null || this.voidchequeId!=null){
        if(this.isOverWriteEO==true){
          formData.append('fileId', this.fileIdvoid);
          formData.append('documentId', this.voidchequeId);
          }
        
       
      }
        // this.fileData=formData

      this.uploadImagesvoidMGA(formData, k)
    }

  }
}
else{
  const formData = new FormData();
  // formData.append('file', this.productPhotofile1);
  var data = this.leadId
  formData.append('leadId', data);
  formData.append('documentFor',"MGA");
  formData.append('documentType',this.documentType)
  formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO));
  formData.append('mgaId',this.mgaId)
  formData.append('accountNumber', this.accountNo);
      formData.append('confirmaccountNo', this.confirmaccountNo);
      formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
      formData.append('transitNumber', this.transitNo);
      formData.append('bankNumber',this.financialInstitutionNo)
  //  this.fileData=formData
  if(this.fileIdvoid!=null || this.voidchequeId!=null){
    formData.append('fileId', this.fileIdvoid);
    formData.append('documentId', this.voidchequeId);
  }


  this.uploadImagesvoidMGA(formData, k)
}
}
async uploadImagesvoidMGA(formData: FormData, k) {

this.loading = true;
if(this.fileIdvoid==null || this.voidchequeId==null){
this.user.submitFormService(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
  this.isOverWriteEO=false
  this.finalDocs1 = data.data;
  this.loading = false;
  Swal.fire({
    text: data.message,  
    icon: 'success',      
    confirmButtonColor: '#CC4037',       
    confirmButtonText: 'Ok'
  }).then((result) => {
    if (result.isConfirmed) {
  this.ProceedPromt();
}
})
  this.uploadVoidChequePopup = false;
  // this.callAgencyApi=false;
  // this.callMgaAPI=true;
  this.openTabs2(2);
  this.getMGADocuments()
  this.showDocumentName1 = data.data.documentName;
  this.fileenoName1 = ""
  this.uploadvoidchequeArray.splice(k, 1);
  this.uploadvoidchequeArray.push(data.data)
  this.bankinfoChecked=false
}, err => {

});
}else{
this.user.submitFormService1(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
  this.isOverWriteEO=false
  this.finalDocs1 = data.data;
  this.loading = false;
  this.fileIdvoid=null;
  this.voidchequeId=null;
  Swal.fire({
    text: data.message,  
    icon: 'success',      
    confirmButtonColor: '#CC4037',       
    confirmButtonText: 'Ok'
  }).then((result) => {
    if (result.isConfirmed) {
  this.ProceedPromt();
}
})
  this.uploadVoidChequePopup= false;
  // this.callAgencyApi=false;
  // this.callMgaAPI=true;
  this.openTabs2(2);
  this.getMGADocuments()
  this.showDocumentName1 = data.data.documentName;
  this.fileenoName1 = ""
  this.uploadvoidchequeArray.splice(k, 1);
  this.uploadvoidchequeArray.push(data.data)
}, err => {

});
}
}
uploadVoidMGA(item, i) {
  var flag = true
  var errormsg = [];
  if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
  if ( this.voidSizeCheck==true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Please upload the filesize less than 4MB')}
  // if(!this.expiryDate || this.expiryDate.length <= 0){this.showdateErrorMsg = true;  flag=false; errormsg.push('Date')} 

  if (flag == true) {
    this.documentType="VOID_CHEQUE"
    this.FileUploadVoidMGA(item, i);

  }
  else {
    this.msg = errormsg.toString();
    this.msgfinal = this.msg.replace(",", '<br />');
    Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')

  }
}



  popupbtntext(){
    this.btnPopupName ="Save"
  }
  showAccountNumber(a) {
    this.eyeIcon=!this.eyeIcon
    if (this.eyeIcon == true){
      if(a=='Confirm'){
        this.confirmaccountNo  = this.eyeIconShowAccountNumber;
      }
      if(a=='Account'){
        this.accountNo  = this.eyeIconShowAccountNumber;
      }  
    }else{
      if(a=='Confirm'){
        this.confirmaccountNo = this.maskaccountNo;
      }
      if(a=='Account'){
        this.accountNo  = this.maskaccountNo;
      }
    }
  }
  updateVoidChequeotpVerificationPopup:boolean=false;
  otpVerificationPopup:boolean=false;
  otpOfVoidCheque:any;
  documentIdForOTPVerificationData:any=null;
  onClickOTPValidation1(item){
    this.otpOfVoidCheque=null;
    this.documentIdForOTPVerificationData=item;
    const request = {
      "documentId": this.documentIdForOTPVerificationData?.id,
      "otp": ""
    }    
    this.base.callPostService(this.config.checkAlreadyAuthoriseForVoidCheque, request).subscribe((data:any) =>{
      // if(data.status==true){
      //   this.onSelected1(this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.id,this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.fileDownloadUrl,this.documentIdForOTPVerificationData?.fileId)
      // }else{
        this.updateVoidChequeotpVerificationPopup=true;
        this.sendOtpForVoidCheque1();
      // }
    },error=>{{
    }},()=>{});
  }
  sendOtpForVoidCheque1(){
    //
    const request = {
      "documentId": this.documentIdForOTPVerificationData?.id,
      "otp": ""
    }    
    this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
      if(data.status==true){
        this.startOtpTimer()
        this.toastr.success("Verification Code sent successfully.");
      }else{
        this.toastr.error(data.message);
      }
    },error=>{{
    }},()=>{});
  }
  verifyOTP1(){
    //
    const request = {
      "documentId": this.documentIdForOTPVerificationData?.id,
      "otp": this.otpOfVoidCheque
    }    
    this.base.callPostService(this.config.verifyOtpForVoidCheque, request).subscribe((data:any) =>{
    if(data.status==true){
        this.uploadVoidChequePopup=true;
        this.updateVoidChequeotpVerificationPopup = false;
        // this.onSelected1(this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.id,this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.fileDownloadUrl,this.documentIdForOTPVerificationData?.fileId)
      }else{
        this.toastr.error("Incorrect Verification Code");
      }
    },error=>{{
    }},()=>{});
  }
  resendVoidChequeOTP1(){
    //
    this.otpOfVoidCheque=null;
    this.updateVoidChequeotpVerificationPopup=true;
    const request = {
      "documentId": this.documentIdForOTPVerificationData?.id,
      "otp": ""
    }    
    this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
      if(data.status==true){
        this.startOtpTimer()
        this.toastr.success("Verification Code sent successfully.");
      }else{
        this.toastr.error(data.message);
      }
    },error=>{{
    }},()=>{});
  }
  prepoulateBankInfo(){
    this.allowUser=false
      this.accountNoErrMsg = false;
      this.financialInstitutionNoErrMsg = false;
      this.transitNoErrMsg = false;
      this.confirmaccountNoErrMsg = false;
      this.transitNo = this.transitNm;
      this.financialInstitutionNo = this.financialInstNumber;
      this.accountNo = this.accNm;
      this.confirmaccountNo = this.accNm;
      this.confirmAccountNumberMatch = false;
      // this.transitNm = this.transitNo;
      // this.financialInstNumber = this.financialInstitutionNo;
      // this.accNm = this.accountNo;
      // this.confirmaccountNo = this.accountNo;
  }

  ProceedPromt(){
    //debugger
    // if(this.commissionsTo!="BROKER" || this.commissionsTo!='Broker'){
    if(this.commissionsTo!='Broker'){
      this.showcheque=true
    }
   
    if(this.Type=='General Agent'){
      this.showdocuments=true
      this.showcheque=true
      this.showdocumentsNA=true
this.showchequeNA=true
this.showdocumentsAgencyNA=true
this.showchequeAgencyNA=true

    }
   
    if(this.Type=='General Agency Rep'){
      this.showdocuments=true
      this.showcheque=true
      this.showdocumentsNA=true
this.showchequeNA=true
// this.showdocumentsAgencyNA=true
this.showchequeAgencyNA=true

    }
    if(this.Type=='Travel Agency Rep'){
      this.showdocuments=true
      this.showcheque=true
      this.showdocumentsNA=true
this.showchequeNA=true
this.showdocumentsAgency=true
this.showdocumentsAgencyNA=true
this.showchequeAgencyNA=true

    }
    if(this.Type=='Travel Agent'){
      if(this.residentProvince!=='NS'){
        this.showlicense1=true
        this.showlicense1NA=true
        this.showlicenseAgencyNA=true
      }
      this.showdocuments=true
      this.showcheque=true      
      this.showdocumentsNA=true  
   this.showchequeNA=true
   this.showdocumentsAgencyNA=true   
   this.showchequeAgencyNA=true
    }

    if(this.showCompany == false && this.showMgaTab==false){
      // if(this.checkedDoc=="Not Approved"|| this.checkedDoc=="More Information Required"){
      //   if(data.data.licences[i].status=="Not Approved"|| data.data.licences[i].status=="More Information Required"){
      //     if (this.uploadvoidchequeArray.length != 0) {
            
      //       for (var i = 0; i < this.uploadvoidchequeArray.length; i++) {
      //           if(this.uploadvoidchequeArray[i].status=="Not Approved"|| this.uploadvoidchequeArray[i].status=="More Information Required"){
      //          }
      //        }
      //     }
      //   }
        
      // }
      
    this.residentLicPresent=false
    for(let i=0; i<this.uploadlicenseArray.length; i++){
    if(this.uploadlicenseArray[i].provinceCode==this.residentProvince || this.uploadlicenseArray[i].province==this.residentProvince || this.uploadlicenseArray[i]?.provinces?.provinceCode==this.residentProvince){

      this.residentLicPresent=true
    }
  }
  if(this.residentLicPresent==true){
      this.showdocumentsNA
   this.showlicense1NA
   this.showchequeNA
   this.showdocumentsAgencyNA
   this.showlicenseAgencyNA
   this.showchequeAgencyNA
   if (this.showdocumentsNA && this.showlicense1NA && this.showchequeNA){
    if (this.showdocuments && this.showlicense1 && this.showcheque) {
      if(this.Type=='Travel Agent'){
        this.loading=true
       this.showforProceed=true
        // this.user.saveDocument(this.leadId).pipe()
        // .subscribe(
        //   data => {
        //     if (data.status == true) {
        //       if(this.uploadlicenseArray[0]?.licensesNumber!=undefined || this.docFileId!=undefined){
        //         this.showdocumentModal = true;
        //         this.uploadDocStatus = true;
        //       }else{
        //         this.showdocumentModal = false;
        //         this.proceed();
        //       }
        //     } else {
        //       Swal.fire("Something went wrong. please try again later.")
        //     }
        //   }, error => {
        //     //  if(this.baseservice.handleError(error)){
        //     //handle Exception from Server 404,401
        //     if (error == "Bad Request") {
        //       Swal.fire("Bad Request. please try again")
        //     }
        //     else {
        //       Swal.fire("Something went wrong. Please check and try again.")
        //     }

        //   }, () => { });
      }else{
        this.loading=true
        this.showforProceed=true
      // Swal.fire({
      //   text: "Have you uploaded an insurance license for each province in which you are licensed?",
      //   icon: 'warning',
      //   showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   cancelButtonText: 'No',
      //   confirmButtonText: 'Yes'
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     // this.user.saveDocument(this.leadId).pipe()
      //     // .subscribe(
      //     //   data => {
      //     //     if (data.status == true) {
      //     //       this.showdocumentModal = true;
      //     //       this.uploadDocStatus = true;
      //     //     } else {
      //     //       Swal.fire("Something went wrong. please try again later.")
      //     //     }
      //     //   }, error => {
      //     //     //  if(this.baseservice.handleError(error)){
      //     //     //handle Exception from Server 404,401
      //     //     if (error == "Bad Request") {
      //     //       Swal.fire("Bad Request. please try again")
      //     //     }
      //     //     else {
      //     //       Swal.fire("Something went wrong. Please check and try again.")
      //     //     }
  
      //     //   }, () => { });
      //   }
      // })
      }
    }
    // if(this.showdocuments == true && this.uploadlicenseArray.length != 0 && this.uploadvoidchequeArray.length != 0){
    //   // this.uploadDocStatus = true;
    // }
    else {
      // Swal.fire("","Please upload all required documents to continue.",'warning')
    }
  }
    else {
      // Swal.fire("","Please upload all the document(s) or complete any pending action(s).",'warning')
    }
  }else{
    // Swal.fire(
    //   {
    //     icon: "warning",
    //     text: "You must provide us with a copy of your “resident province” license to proceed with the sign up process.",
    //     footer: '<span style="font-size:16px;color:#CC4037">“Resident Province”- The province where you currently reside and operate out of.</span>'
    //   }
    // );
  }
  }else if(this.showCompany == true && this.showMgaTab==false){
    this.residentLicPresent=false
    for(let i=0; i<this.getLicencesDataBroker.length; i++){
    if(this.getLicencesDataBroker[i].provinceCode==this.residentProvince){

      this.residentLicPresent=true
    }
  }
  if(this.residentLicPresent==true){
    // this.callIndividualDoc();
    // this.callAgencyDoc();
        this.showcheque=true
        this.showchequeNA=true;
      if (this.showdocumentsNA && this.showlicense1NA && this.showchequeNA && this.showdocumentsAgencyNA && this.showlicenseAgencyNA && this.showchequeAgencyNA){
    if (this.showdocuments && this.showlicense1 && this.showcheque && this.showdocumentsAgency && this.showlicenseAgency && this.showchequeAgency) {
      this.loading=true
      this.showforProceed=true
      // if(this.showCompany == true){
      //   this.callAgencyDoc();
      // }
      // if (this.showdocuments) {
        // Swal.fire({
        //   text: "Have you uploaded an insurance license for each province in which you are licensed?",
        //   icon: 'warning',
        //   showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   cancelButtonColor: '#d33',
        //   cancelButtonText: 'No',
        //   confirmButtonText: 'Yes'
        // }).then((result) => {
        //   if (result.isConfirmed) {
        // //     this.user.saveDocument(this.leadId).pipe()
        // // .subscribe(
        // //   data => {
        // //     if (data.status == true) {
        // //       this.showdocumentModal = true;
        // //       this.uploadDocStatus = true;
        // //     } else {
        // //       Swal.fire("Something went wrong. please try again later.")
        // //     }
        // //   }, error => {
        // //     //  if(this.baseservice.handleError(error)){
        // //     //handle Exception from Server 404,401
        // //     if (error == "Bad Request") {
        // //       Swal.fire("Bad Request. please try again")
        // //     }
        // //     else {
        // //       Swal.fire("Something went wrong. Please check and try again.")
        // //     }

        // //   }, () => { });
        //   }
        // })
    }
    // if(this.showdocuments == true && this.uploadlicenseArray.length != 0 && this.uploadvoidchequeArray.length != 0){
    //   // this.uploadDocStatus = true;
    // }
    else {
      // Swal.fire("","Please upload all required documents to continue.",'warning')
      
      if (!this.showdocuments || !this.showlicense1){
        // this.callIndividualDoc();
        
        // this.openTabs2(0);
        this.tabs2[0].active2;
        
    
      }
      if(!this.showdocumentsAgency || !this.showlicenseAgency ){
        //this.companydocmodal = true;
        // this.callAgencyDoc();
        // this.openTabs2(1);
        this.tabs2[1].active2;
        
      }
      if( !this.showchequeAgency ){
        // this.callAgencyDoc();

        //this.companydocmodal = true;
        // this.callAgencyDoc();
        // this.openTabs2(1);
        this.tabs2[1].active2;
      }
      setTimeout(() => 
      {
        if (!this.showdocuments || !this.showlicense1 || !this.showcheque || !this.showdocumentsAgency || !this.showlicenseAgency || !this.showchequeAgency){
          // Swal.fire("","Please upload all required 'Individual' and 'Company' documents to continue.",'warning');
        }
      },
      2000);
    }
  }
    else{
      // Swal.fire("","Please upload all the document(s) or complete any pending action(s).",'warning')
    }
  }
  else{
    // Swal.fire(
    //   {
    //     icon: "warning",
    //     text: "You must provide us with a copy of your “resident province” license to proceed with the sign up process.",
    //     footer: '<span style="font-size:16px;color:#CC4037">“Resident Province”- The province where you currently reside and operate out of.</span>'
    //   }
    // );
  }
  }
  else{
    //debugger
    this.residentLicPresent=false
    for(let i=0; i<this.getLicencesDataBroker.length; i++){
    if(this.getLicencesDataBroker[i].provinceCode==this.residentProvince || this.uploadlicenseArray[i].province==this.residentProvince || this.uploadlicenseArray[i]?.provinces?.provinceCode==this.residentProvince){

      this.residentLicPresent=true
    }
  }
  if(this.residentLicPresent==true){
this.showcheque=true
this.showchequeNA=true;

if (this.showdocumentsNA && this.showlicense1NA && this.showchequeNA && this.showdocumentsMgaNA && this.showlicenseMgaNA && this.showchequeMgaNA){
if (this.showdocuments && this.showlicense1 && this.showcheque  && this.showdocumentsMGA && this.showlicenseMGA && this.showchequeMGA) {
  this.loading=true
  this.showforProceed=true
// if(this.showCompany == true){
//   this.callAgencyDoc();
// }
// if (this.showdocuments) {
// Swal.fire({
//   text: "Have you uploaded an insurance license for each province in which you are licensed?",
//   icon: 'warning',
//   showCancelButton: true,
//   confirmButtonColor: '#3085d6',
//   cancelButtonColor: '#d33',
//   cancelButtonText: 'No',
//   confirmButtonText: 'Yes'
// }).then((result) => {
//   if (result.isConfirmed) {
// //     this.user.saveDocument(this.leadId).pipe()
// // .subscribe(
// //   data => {
// //     if (data.status == true) {
// //       this.showdocumentModal = true;
// //       this.uploadDocStatus = true;
// //     } else {
// //       Swal.fire("Something went wrong. please try again later.")
// //     }
// //   }, error => {
// //     //  if(this.baseservice.handleError(error)){
// //     //handle Exception from Server 404,401
// //     if (error == "Bad Request") {
// //       Swal.fire("Bad Request. please try again")
// //     }
// //     else {
// //       Swal.fire("Something went wrong. Please check and try again.")
// //     }

// //   }, () => { });
//   }
// })
}
// if(this.showdocuments == true && this.uploadlicenseArray.length != 0 && this.uploadvoidchequeArray.length != 0){
//   // this.uploadDocStatus = true;
// }
else {
// Swal.fire("","Please upload all required documents to continue.",'warning')

if (!this.showdocuments || !this.showlicense1){
// this.callIndividualDoc();

// this.openTabs2(0);
this.tabs2[0].active2;


}

if( !this.showchequeMGA  || this.showdocumentsMGA || this.showlicenseMGA){
// this.callMgaDoc();

//this.companydocmodal = true;
// this.callAgencyDoc();
// this.openTabs2(2);
this.tabs2[2].active2;
}
setTimeout(() => 
{
if (!this.showdocuments || !this.showlicense1 || !this.showcheque || !this.showdocumentsAgency || !this.showlicenseAgency || !this.showchequeAgency || !this.showdocumentsMGA || !this.showlicenseMGA || !this.showchequeMGA){
  // Swal.fire("","Please upload all required 'Individual' and 'Company' documents to continue.",'warning');
}
},
2000);
}
}
else{
// Swal.fire("","Please upload all the document(s) or complete any pending action(s).",'warning')
}
}
else{
  // Swal.fire(
  //   {
  //     icon: "warning",
  //     text: "You must provide us with a copy of your “resident province” license to proceed with the sign up process.",
  //     footer: '<span style="font-size:16px;color:#CC4037">“Resident Province”- The province where you currently reside and operate out of.</span>'
  //   }
  // );
}
  }
  }
  cancelLoding(){
    //debugger
    this.loading=false
    this.showforProceed = false;
  }
  requestLicensarrayEO=[]
  getEORequest(){
      this.user.getLicenseRequestCall(this.leadId,'EO').pipe()
    .subscribe(
        data => {
          if(data.status==true){
          this.requestLicensarrayEO=[]
          this.requestLicensarrayEO=data.data
          this.showforProceed=false
          }else{
          this.requestLicensarrayEO=[]
          }
        },error=>{
            },()=>{});
    }
    requestLicensarrayVoidCheque=[]
  getVoidChequeRequest(){
      this.user.getLicenseRequestCall(this.leadId,'VOID_CHEQUE').pipe()
    .subscribe(
        data => {
          if(data.status==true){
          this.requestLicensarrayVoidCheque=[]
          this.requestLicensarrayVoidCheque=data.data
          this.showforProceed=false
          }else{
          this.requestLicensarrayVoidCheque=[]
          }
        },error=>{
            },()=>{});
    }
  ClosePopupRequested() {
    this.isDocumentRequested = false
  }
  OverwriteEODocRequested(data) {
    this.requestedData=data
    this.isDocumentRequested = true
    if (data.type == 'LINCENCES') {
      this.uploadLicensePopup = true
    }
    if (data.type == 'EO') {
      this.uploadEOPopup = true
    }
    if (data.type == 'VOID_CHEQUE') {
      this.editBankInfo()
      this.transitNo =null;
      this.financialInstitutionNo=null;
      this.accountNo=null;
      this.confirmaccountNo =null;
      this.maskaccountNo =null;
      this.eyeIconShowAccountNumber =null;
      this.bankinfoChecked = false;
      this.uploadVoidChequePopup = true
    }
  }
  RequestedDocumentAddUpdateEO(type) {
    let docFor = '';
if (!this.showCompanyDelete && !this.callMgaAPI) {
  docFor = 'LEAD';
} else if (this.showCompanyDelete && !this.callMgaAPI) {
  docFor = 'Agency';
} else if (!this.showCompanyDelete && this.callMgaAPI) {
  docFor = 'MGA';
}
    const formData = new FormData();
    formData.append('file', this.FileDataList[0]);
    formData.append('expiryDate', this.expiryDate);
    formData.append('effectiveDate', this.effectiveDate);
    formData.append('leadId', this.leadId);
    // formData.append('agencyId',this.agencyId)
    formData.append('DocNumber',this.policyNumber)
    // formData.append('accountNumber',this.agencyId)
    // formData.append('bankNumber',this.policyNumber)
    formData.append('docName',this.fileenoName)
    formData.append('documentFor',docFor)
    
    formData.append('documentType',type)
    formData.append('isOverwrite','true')   
if(this.showCompanyDelete==true){
          formData.append('agencyId ', this.agencyId);
        }
if(this.callMgaAPI==true){
formData.append('mgaId',this.mgaId)
        }
    if( this.requestedData.documentId!=undefined || this.requestedData.documentId!=null){
      formData.append('documentId', this.requestedData.documentId)
    }
    formData.append('requestedId', this.requestedData.id);
    this.uploadRequestedDoc(formData)
  }
  RequestedDocumentAddUpdateLic(uploadlic, k,type) {
    let docFor = '';
    if (!this.showCompanyDelete && !this.callMgaAPI) {
      docFor = 'LEAD';
    } else if (this.showCompanyDelete && !this.callMgaAPI) {
      docFor = 'Agency';
    } else if (!this.showCompanyDelete && this.callMgaAPI) {
      docFor = 'MGA';
    }
    const formData = new FormData();
    formData.append('file',this.FileDataListLic[0]);
    formData.append('expiryDate', uploadlic.expiryDateLic);
    formData.append('effectiveDate', uploadlic.effectiveDateLic);

    formData.append('leadId', this.leadId);
    formData.append('DocNumber', uploadlic.licenseNumber);
    // formData.append('docName', uploadlic.licenseName);
    formData.append('licencesType', uploadlic.type);
    formData.append('province', uploadlic.province);
    // formData.append('agencyId',this.agencyId)
    formData.append('documentFor',docFor)
    
    formData.append('documentType',type)
    formData.append('isOverwrite','false')    
if(this.showCompanyDelete==true){
          formData.append('agencyId ', this.agencyId);
        }
if(this.callMgaAPI==true){
formData.append('mgaId',this.mgaId)
        }

if(this.requestedData.id !=null ){
formData.append('requestedId', this.requestedData.id);
}
    // this.fileData=formData

    this.uploadRequestedDoc(formData)
  }
  RequestedDocumentAddUpdateVoid(uploadlic, k,type) {
    let docFor = '';
    if (!this.showCompanyDelete && !this.callMgaAPI) {
      docFor = 'LEAD';
    } else if (this.showCompanyDelete && !this.callMgaAPI) {
      docFor = 'Agency';
    } else if (!this.showCompanyDelete && this.callMgaAPI) {
      docFor = 'MGA';
    }
    const formData = new FormData();
    formData.append('file', this.FileDataList1[0]);
    formData.append('leadId', this.leadId);
    formData.append('accountNumber', this.accountNo);
    formData.append('confirmaccountNo', this.confirmaccountNo);
    formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
    formData.append('transitNumber', this.transitNo);
    formData.append('bankNumber',this.financialInstitutionNo)
    formData.append('documentFor',docFor);
        formData.append('documentType',type)
        formData.append('isOverwrite','true');
if(this.showCompanyDelete==true){
            formData.append('agencyId ', this.agencyId);
          }
if(this.callMgaAPI==true){
  formData.append('mgaId',this.mgaId)
          }
        
    if(this.fileIdvoid!=null ){
      formData.append('fileId', this.fileIdvoid);
    }
    if(this.requestedData.documentId!=null){        
        formData.append('documentId', this.requestedData.documentId);
    }
    formData.append('requestedId', this.requestedData.id);
    this.uploadRequestedDoc(formData)
  }

  uploadRequestedDoc(formData){
    this.loading = true;
    this.user.submitFormService(this.config.v2GetRequestedDocumentAddUpdate, formData).subscribe((data: any) => {
      this.loading = false;
      this.isDocumentRequested = false
      this.uploadEOPopup = false
      this.uploadVoidChequePopup = false
      this.uploadLicensePopup = false;
      if (!this.showCompanyDelete && !this.callMgaAPI) {
        this.callIndividualDoc();
      } else if (this.showCompanyDelete && !this.callMgaAPI) {
        this.callAgencyDoc();
      } else if (!this.showCompanyDelete && this.callMgaAPI) {
        this.callMgaDoc();
      }     
      Swal.fire({
        text: data.message,  
        icon: 'success',      
        confirmButtonColor: '#CC4037',       
        confirmButtonText: 'Ok'
      }).then((result) => {
        if (result.isConfirmed) {
      this.ProceedPromt();      
    }
  }) 
      
      //  this.showlicense=true;
      this.fileenoNameLic = "";
      // this.uploadlicenseArray.splice(k, 1);
      // this.uploadlicenseArray.push(data.data)
    }, err => {
  
    });  
  }
  startOtpTimer() {
    this.remainingSecondsSIN = 300; // 5 minutes = 300 seconds
    this.isOtpExpiredSIN = false;
    this.updateTimerDisplay();
  
    if (this.otpTimerSIN) {
      clearInterval(this.otpTimerSIN);
    }
  
    this.otpTimerSIN = setInterval(() => {
      if (this.remainingSecondsSIN > 0) {
        this.remainingSecondsSIN--;
        this.updateTimerDisplay();
      } else {
        //debugger
        this.isOtpExpiredSIN = true;
        clearInterval(this.otpTimerSIN);
      }
    }, 1000);
  }
  
  updateTimerDisplay() {
    const minutes = Math.floor(this.remainingSecondsSIN / 60);
    const seconds = this.remainingSecondsSIN % 60;
    this.otpTimerDisplaySIN = `${this.pad(minutes)}:${this.pad(seconds)}`;
  }
  
  pad(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }
}
